// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file cortado/v1/settings.proto (package cortado.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Questionnaire } from "./questionnaires_pb";
import { file_cortado_v1_questionnaires } from "./questionnaires_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file cortado/v1/settings.proto.
 */
export const file_cortado_v1_settings: GenFile = /*@__PURE__*/
  fileDesc("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", [file_cortado_v1_questionnaires]);

/**
 * OrganizationEventType represents a single organization-scoped, user
 * configurable event type. Records reference an event type by its immutable
 * `key`; `label` is the display name and may be renamed freely.
 *
 * @generated from message cortado.v1.OrganizationEventType
 */
export type OrganizationEventType = Message<"cortado.v1.OrganizationEventType"> & {
  /**
   * Unique identifier for the event type
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Immutable key stored on records (e.g. "Wedding")
   *
   * @generated from field: string key = 2;
   */
  key: string;

  /**
   * Display label (e.g. "Wedding")
   *
   * @generated from field: string label = 3;
   */
  label: string;

  /**
   * Display color token
   *
   * @generated from field: string color = 4;
   */
  color: string;

  /**
   * Display icon token
   *
   * @generated from field: string icon = 5;
   */
  icon: string;

  /**
   * Sort order within the organization
   *
   * @generated from field: int32 display_order = 6;
   */
  displayOrder: number;

  /**
   * False when the event type has been archived
   *
   * @generated from field: bool is_active = 7;
   */
  isActive: boolean;

  /**
   * True for the rows seeded on organization creation
   *
   * @generated from field: bool is_system = 8;
   */
  isSystem: boolean;

  /**
   * Whether the inquiry/booking form should collect a company name for this event type
   *
   * @generated from field: bool collect_company_name = 9;
   */
  collectCompanyName: boolean;

  /**
   * Optional override for quote expiration. When unset, the org default applies.
   *
   * @generated from field: optional cortado.v1.QuoteExpirationAnchorEnum quote_expiration_anchor = 10;
   */
  quoteExpirationAnchor?: QuoteExpirationAnchorEnum;

  /**
   * Offset days for quote_expiration_anchor. Required when quote_expiration_anchor is set.
   *
   * @generated from field: optional int32 quote_expiration_offset_days = 11;
   */
  quoteExpirationOffsetDays?: number;

  /**
   * Event-type-specific questionnaire items appended after the org default
   * when a booking snapshot is generated.
   *
   * @generated from field: optional cortado.v1.Questionnaire questionnaire = 12;
   */
  questionnaire?: Questionnaire;
};

/**
 * Describes the message cortado.v1.OrganizationEventType.
 * Use `create(OrganizationEventTypeSchema)` to create a new message.
 */
export const OrganizationEventTypeSchema: GenMessage<OrganizationEventType> = /*@__PURE__*/
  messageDesc(file_cortado_v1_settings, 0);

/**
 * PermissionInfo describes one assignable permission for the role-editor UI: its
 * stored key, a display label and description, the product-domain category it
 * belongs to, the key it implies (empty when it implies nothing beyond itself), and
 * whether it is the "Manage" level of a two-level domain (as opposed to "View").
 *
 * @generated from message cortado.v1.PermissionInfo
 */
export type PermissionInfo = Message<"cortado.v1.PermissionInfo"> & {
  /**
   * Stored key, e.g. "Admin", "ContactsView", "ContactsManage"
   *
   * @generated from field: string key = 1;
   */
  key: string;

  /**
   * Human-readable label, e.g. "Manage Contacts"
   *
   * @generated from field: string label = 2;
   */
  label: string;

  /**
   * Human-readable description of what the permission grants
   *
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * Product-domain category, e.g. "Contacts", "Billing", "Full access"
   *
   * @generated from field: string category = 4;
   */
  category: string;

  /**
   * Key of the permission this one implies (empty if none)
   *
   * @generated from field: string implies_key = 5;
   */
  impliesKey: string;

  /**
   * True if this is the "Manage" level of a two-level domain; false for "View"-level
   * or view-only domains
   *
   * @generated from field: bool manage_level = 6;
   */
  manageLevel: boolean;
};

/**
 * Describes the message cortado.v1.PermissionInfo.
 * Use `create(PermissionInfoSchema)` to create a new message.
 */
export const PermissionInfoSchema: GenMessage<PermissionInfo> = /*@__PURE__*/
  messageDesc(file_cortado_v1_settings, 1);

/**
 * Settings contains all system enum settings
 *
 * @generated from message cortado.v1.Settings
 */
export type Settings = Message<"cortado.v1.Settings"> & {
  /**
   * @generated from field: repeated cortado.v1.InquiryStageEnum inquiry_stages = 1;
   */
  inquiryStages: InquiryStageEnum[];

  /**
   * @generated from field: repeated cortado.v1.BookingStageEnum booking_stages = 2;
   */
  bookingStages: BookingStageEnum[];

  /**
   * @generated from field: repeated cortado.v1.EventStageEnum event_stages = 3;
   */
  eventStages: EventStageEnum[];

  /**
   * @generated from field: repeated cortado.v1.QuoteStatusEnum quote_statuses = 4;
   */
  quoteStatuses: QuoteStatusEnum[];

  /**
   * @generated from field: repeated cortado.v1.PaymentStatusEnum payment_statuses = 5;
   */
  paymentStatuses: PaymentStatusEnum[];

  /**
   * @generated from field: repeated cortado.v1.InvoiceStatusEnum invoice_statuses = 15;
   */
  invoiceStatuses: InvoiceStatusEnum[];

  /**
   * @generated from field: repeated cortado.v1.ItemUnitEnum item_units = 6;
   */
  itemUnits: ItemUnitEnum[];

  /**
   * Deprecated: global legacy values for deployed clients. New clients should
   * use organization_event_types.
   *
   * @generated from field: repeated cortado.v1.EventTypeEnum event_types = 7 [deprecated = true];
   * @deprecated
   */
  eventTypes: EventTypeEnum[];

  /**
   * @generated from field: repeated cortado.v1.ParentTypeEnum parent_types = 8;
   */
  parentTypes: ParentTypeEnum[];

  /**
   * @generated from field: repeated cortado.v1.DiscountTypeEnum discount_types = 9;
   */
  discountTypes: DiscountTypeEnum[];

  /**
   * @generated from field: repeated cortado.v1.UserSchedulingStatusEnum user_scheduling_statuses = 10;
   */
  userSchedulingStatuses: UserSchedulingStatusEnum[];

  /**
   * @generated from field: repeated cortado.v1.TaskStatusEnum task_statuses = 11;
   */
  taskStatuses: TaskStatusEnum[];

  /**
   * @generated from field: repeated cortado.v1.OrganizationRoleEnum organization_roles = 12;
   */
  organizationRoles: OrganizationRoleEnum[];

  /**
   * @generated from field: repeated cortado.v1.OrganizationFeatureEnum features = 13;
   */
  features: OrganizationFeatureEnum[];

  /**
   * @generated from field: repeated cortado.v1.PermissionEnum system_permissions = 14;
   */
  systemPermissions: PermissionEnum[];

  /**
   * @generated from field: repeated cortado.v1.PaymentScheduleStatusEnum payment_schedule_statuses = 16;
   */
  paymentScheduleStatuses: PaymentScheduleStatusEnum[];

  /**
   * @generated from field: repeated cortado.v1.PaymentIntentStatusEnum payment_intent_statuses = 17;
   */
  paymentIntentStatuses: PaymentIntentStatusEnum[];

  /**
   * @generated from field: repeated cortado.v1.StripePaymentStatusEnum stripe_payment_statuses = 18;
   */
  stripePaymentStatuses: StripePaymentStatusEnum[];

  /**
   * @generated from field: repeated cortado.v1.PaymentOutcomeTypeEnum payment_outcome_types = 19;
   */
  paymentOutcomeTypes: PaymentOutcomeTypeEnum[];

  /**
   * @generated from field: repeated cortado.v1.PaymentNetworkStatusEnum payment_network_statuses = 20;
   */
  paymentNetworkStatuses: PaymentNetworkStatusEnum[];

  /**
   * @generated from field: repeated cortado.v1.PaymentRiskLevelEnum payment_risk_levels = 21;
   */
  paymentRiskLevels: PaymentRiskLevelEnum[];

  /**
   * @generated from field: repeated cortado.v1.CardCheckResultEnum card_check_results = 22;
   */
  cardCheckResults: CardCheckResultEnum[];

  /**
   * @generated from field: repeated cortado.v1.ManualPaymentMethodEnum manual_payment_methods = 23;
   */
  manualPaymentMethods: ManualPaymentMethodEnum[];

  /**
   * @generated from field: repeated cortado.v1.CheckoutSessionStatusEnum checkout_session_statuses = 24;
   */
  checkoutSessionStatuses: CheckoutSessionStatusEnum[];

  /**
   * @generated from field: repeated cortado.v1.DisputeStatusEnum dispute_statuses = 25;
   */
  disputeStatuses: DisputeStatusEnum[];

  /**
   * @generated from field: repeated cortado.v1.FeedbackTypeEnum feedback_types = 26;
   */
  feedbackTypes: FeedbackTypeEnum[];

  /**
   * @generated from field: repeated cortado.v1.InquiryTagEnum inquiry_tags = 27;
   */
  inquiryTags: InquiryTagEnum[];

  /**
   * @generated from field: repeated cortado.v1.StripeCheckoutPaymentMethodEnum stripe_checkout_payment_methods = 28;
   */
  stripeCheckoutPaymentMethods: StripeCheckoutPaymentMethodEnum[];

  /**
   * @generated from field: repeated cortado.v1.InquiryRejectReasonEnum inquiry_reject_reasons = 29;
   */
  inquiryRejectReasons: InquiryRejectReasonEnum[];

  /**
   * Organization-scoped event types, including archived rows so historical
   * records keep their labels, colors, icons, and filter options.
   *
   * @generated from field: repeated cortado.v1.OrganizationEventType organization_event_types = 30;
   */
  organizationEventTypes: OrganizationEventType[];
};

/**
 * Describes the message cortado.v1.Settings.
 * Use `create(SettingsSchema)` to create a new message.
 */
export const SettingsSchema: GenMessage<Settings> = /*@__PURE__*/
  messageDesc(file_cortado_v1_settings, 2);

/**
 * AiOrbConfig is the platform-wide (not org-scoped) visual configuration for
 * the AI assistant orb (WebGL). Superadmins edit it in the admin console;
 * tenant clients read it once on load. When unset, clients fall back to their
 * own built-in defaults.
 *
 * @generated from message cortado.v1.AiOrbConfig
 */
export type AiOrbConfig = Message<"cortado.v1.AiOrbConfig"> & {
  /**
   * Hex color stops (e.g. "#3366ff"), 2-4 entries.
   *
   * @generated from field: repeated string colors = 1;
   */
  colors: string[];

  /**
   * @generated from field: double duration = 2;
   */
  duration: number;

  /**
   * @generated from field: double blob_scale = 3;
   */
  blobScale: number;

  /**
   * @generated from field: double flow = 4;
   */
  flow: number;

  /**
   * @generated from field: double turbulence = 5;
   */
  turbulence: number;

  /**
   * @generated from field: double shift = 6;
   */
  shift: number;

  /**
   * @generated from field: double balance = 7;
   */
  balance: number;

  /**
   * @generated from field: double chroma = 8;
   */
  chroma: number;

  /**
   * @generated from field: double contrast = 9;
   */
  contrast: number;

  /**
   * @generated from field: double rim = 10;
   */
  rim: number;

  /**
   * @generated from field: double specular = 11;
   */
  specular: number;

  /**
   * @generated from field: double inner = 12;
   */
  inner: number;

  /**
   * @generated from field: double wobble = 13;
   */
  wobble: number;

  /**
   * @generated from field: double iridescence = 14;
   */
  iridescence: number;

  /**
   * @generated from field: double shading = 15;
   */
  shading: number;

  /**
   * @generated from field: double refraction = 16;
   */
  refraction: number;

  /**
   * @generated from field: double light_x = 17;
   */
  lightX: number;

  /**
   * @generated from field: double light_y = 18;
   */
  lightY: number;

  /**
   * @generated from field: double aberration = 19;
   */
  aberration: number;

  /**
   * @generated from field: double grain = 20;
   */
  grain: number;

  /**
   * @generated from field: double softness = 21;
   */
  softness: number;

  /**
   * @generated from field: double glow = 22;
   */
  glow: number;
};

/**
 * Describes the message cortado.v1.AiOrbConfig.
 * Use `create(AiOrbConfigSchema)` to create a new message.
 */
export const AiOrbConfigSchema: GenMessage<AiOrbConfig> = /*@__PURE__*/
  messageDesc(file_cortado_v1_settings, 3);

/**
 * AiOrbStateConfigs holds one fully independent AiOrbConfig per orb state.
 *
 * @generated from message cortado.v1.AiOrbStateConfigs
 */
export type AiOrbStateConfigs = Message<"cortado.v1.AiOrbStateConfigs"> & {
  /**
   * @generated from field: cortado.v1.AiOrbConfig idle = 1;
   */
  idle?: AiOrbConfig;

  /**
   * @generated from field: cortado.v1.AiOrbConfig working = 2;
   */
  working?: AiOrbConfig;

  /**
   * @generated from field: cortado.v1.AiOrbConfig ready = 3;
   */
  ready?: AiOrbConfig;
};

/**
 * Describes the message cortado.v1.AiOrbStateConfigs.
 * Use `create(AiOrbStateConfigsSchema)` to create a new message.
 */
export const AiOrbStateConfigsSchema: GenMessage<AiOrbStateConfigs> = /*@__PURE__*/
  messageDesc(file_cortado_v1_settings, 4);

/**
 * GetSystemSettingsRequest is sent to retrieve system settings
 *
 * @generated from message cortado.v1.GetSystemSettingsRequest
 */
export type GetSystemSettingsRequest = Message<"cortado.v1.GetSystemSettingsRequest"> & {
  /**
   * Organization whose event types should be returned. Every other enum on
   * this RPC is global; event_types is per-organization, so a user who belongs
   * to more than one organization must say which one they mean. Optional for
   * single-organization callers, who are unambiguous.
   *
   * @generated from field: optional string organization_id = 1;
   */
  organizationId?: string;
};

/**
 * Describes the message cortado.v1.GetSystemSettingsRequest.
 * Use `create(GetSystemSettingsRequestSchema)` to create a new message.
 */
export const GetSystemSettingsRequestSchema: GenMessage<GetSystemSettingsRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_settings, 5);

/**
 * GetSystemSettingsResponse contains all system settings
 *
 * @generated from message cortado.v1.GetSystemSettingsResponse
 */
export type GetSystemSettingsResponse = Message<"cortado.v1.GetSystemSettingsResponse"> & {
  /**
   * @generated from field: cortado.v1.Settings settings = 1;
   */
  settings?: Settings;
};

/**
 * Describes the message cortado.v1.GetSystemSettingsResponse.
 * Use `create(GetSystemSettingsResponseSchema)` to create a new message.
 */
export const GetSystemSettingsResponseSchema: GenMessage<GetSystemSettingsResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_settings, 6);

/**
 * InquiryStageEnum represents the stage of an inquiry
 *
 * @generated from enum cortado.v1.InquiryStageEnum
 */
export enum InquiryStageEnum {
  /**
   * @generated from enum value: INQUIRY_STAGE_UNKNOWN = 0;
   */
  INQUIRY_STAGE_UNKNOWN = 0,

  /**
   * @generated from enum value: INQUIRY_STAGE_NEW = 1;
   */
  INQUIRY_STAGE_NEW = 1,

  /**
   * @generated from enum value: INQUIRY_STAGE_IN_PROGRESS = 2;
   */
  INQUIRY_STAGE_IN_PROGRESS = 2,

  /**
   * @generated from enum value: INQUIRY_STAGE_QUOTE_SENT = 3;
   */
  INQUIRY_STAGE_QUOTE_SENT = 3,

  /**
   * @generated from enum value: INQUIRY_STAGE_ACCEPTED = 4;
   */
  INQUIRY_STAGE_ACCEPTED = 4,

  /**
   * @generated from enum value: INQUIRY_STAGE_REJECTED = 5;
   */
  INQUIRY_STAGE_REJECTED = 5,

  /**
   * @generated from enum value: INQUIRY_STAGE_STALE = 6;
   */
  INQUIRY_STAGE_STALE = 6,

  /**
   * Another organization accepted the lead as a referral. Closed.
   *
   * @generated from enum value: INQUIRY_STAGE_REFERRED = 7;
   */
  INQUIRY_STAGE_REFERRED = 7,
}

/**
 * Describes the enum cortado.v1.InquiryStageEnum.
 */
export const InquiryStageEnumSchema: GenEnum<InquiryStageEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_settings, 0);

/**
 * BookingStageEnum represents the stage of a booking
 *
 * @generated from enum cortado.v1.BookingStageEnum
 */
export enum BookingStageEnum {
  /**
   * @generated from enum value: BOOKING_STAGE_UNKNOWN = 0;
   */
  BOOKING_STAGE_UNKNOWN = 0,

  /**
   * @generated from enum value: BOOKING_STAGE_UPCOMING = 1;
   */
  BOOKING_STAGE_UPCOMING = 1,

  /**
   * @generated from enum value: BOOKING_STAGE_COMPLETE = 2;
   */
  BOOKING_STAGE_COMPLETE = 2,

  /**
   * @generated from enum value: BOOKING_STAGE_CANCELLED = 3;
   */
  BOOKING_STAGE_CANCELLED = 3,
}

/**
 * Describes the enum cortado.v1.BookingStageEnum.
 */
export const BookingStageEnumSchema: GenEnum<BookingStageEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_settings, 1);

/**
 * EventStageEnum represents the stage of an event
 *
 * @generated from enum cortado.v1.EventStageEnum
 */
export enum EventStageEnum {
  /**
   * @generated from enum value: EVENT_STAGE_UNKNOWN = 0;
   */
  EVENT_STAGE_UNKNOWN = 0,

  /**
   * @generated from enum value: EVENT_STAGE_UPCOMING = 1;
   */
  EVENT_STAGE_UPCOMING = 1,

  /**
   * @generated from enum value: EVENT_STAGE_COMPLETE = 2;
   */
  EVENT_STAGE_COMPLETE = 2,

  /**
   * @generated from enum value: EVENT_STAGE_CANCELLED = 3;
   */
  EVENT_STAGE_CANCELLED = 3,

  /**
   * @generated from enum value: EVENT_STAGE_RESCHEDULED = 4;
   */
  EVENT_STAGE_RESCHEDULED = 4,

  /**
   * @generated from enum value: EVENT_STAGE_POSTPONED = 5;
   */
  EVENT_STAGE_POSTPONED = 5,
}

/**
 * Describes the enum cortado.v1.EventStageEnum.
 */
export const EventStageEnumSchema: GenEnum<EventStageEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_settings, 2);

/**
 * EventListBucketEnum preserves the Events page's mutually-exclusive tab
 * semantics while allowing filtering and pagination to happen on the server.
 *
 * @generated from enum cortado.v1.EventListBucketEnum
 */
export enum EventListBucketEnum {
  /**
   * @generated from enum value: EVENT_LIST_BUCKET_ENUM_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: EVENT_LIST_BUCKET_ENUM_UPCOMING = 1;
   */
  UPCOMING = 1,

  /**
   * @generated from enum value: EVENT_LIST_BUCKET_ENUM_COMPLETED = 2;
   */
  COMPLETED = 2,
}

/**
 * Describes the enum cortado.v1.EventListBucketEnum.
 */
export const EventListBucketEnumSchema: GenEnum<EventListBucketEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_settings, 3);

/**
 * EventTypeEnum is retained for wire compatibility with deployed clients.
 * New clients should use the adjacent event_type_key string fields instead.
 *
 * @generated from enum cortado.v1.EventTypeEnum
 */
export enum EventTypeEnum {
  /**
   * @generated from enum value: EVENT_TYPE_UNKNOWN = 0;
   */
  EVENT_TYPE_UNKNOWN = 0,

  /**
   * @generated from enum value: EVENT_TYPE_CORPORATE = 1;
   */
  EVENT_TYPE_CORPORATE = 1,

  /**
   * @generated from enum value: EVENT_TYPE_CONFERENCE = 2;
   */
  EVENT_TYPE_CONFERENCE = 2,

  /**
   * @generated from enum value: EVENT_TYPE_WEDDING = 3;
   */
  EVENT_TYPE_WEDDING = 3,

  /**
   * @generated from enum value: EVENT_TYPE_NON_PROFIT = 4;
   */
  EVENT_TYPE_NON_PROFIT = 4,

  /**
   * @generated from enum value: EVENT_TYPE_PARTY = 5;
   */
  EVENT_TYPE_PARTY = 5,

  /**
   * @generated from enum value: EVENT_TYPE_RETAIL = 6;
   */
  EVENT_TYPE_RETAIL = 6,

  /**
   * @generated from enum value: EVENT_TYPE_OTHER = 7;
   */
  EVENT_TYPE_OTHER = 7,
}

/**
 * Describes the enum cortado.v1.EventTypeEnum.
 */
export const EventTypeEnumSchema: GenEnum<EventTypeEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_settings, 4);

/**
 * QuoteStatusEnum represents the status of a quote
 *
 * @generated from enum cortado.v1.QuoteStatusEnum
 */
export enum QuoteStatusEnum {
  /**
   * @generated from enum value: QUOTE_STATUS_UNKNOWN = 0;
   */
  QUOTE_STATUS_UNKNOWN = 0,

  /**
   * @generated from enum value: QUOTE_STATUS_DRAFT = 1;
   */
  QUOTE_STATUS_DRAFT = 1,

  /**
   * @generated from enum value: QUOTE_STATUS_SENT = 2;
   */
  QUOTE_STATUS_SENT = 2,

  /**
   * @generated from enum value: QUOTE_STATUS_VIEWED = 3;
   */
  QUOTE_STATUS_VIEWED = 3,

  /**
   * @generated from enum value: QUOTE_STATUS_REVISED = 4;
   */
  QUOTE_STATUS_REVISED = 4,

  /**
   * @generated from enum value: QUOTE_STATUS_ACCEPTED = 5;
   */
  QUOTE_STATUS_ACCEPTED = 5,

  /**
   * @generated from enum value: QUOTE_STATUS_REJECTED = 6;
   */
  QUOTE_STATUS_REJECTED = 6,

  /**
   * @generated from enum value: QUOTE_STATUS_EXPIRED = 7;
   */
  QUOTE_STATUS_EXPIRED = 7,

  /**
   * @generated from enum value: QUOTE_STATUS_CANCELLED = 8;
   */
  QUOTE_STATUS_CANCELLED = 8,
}

/**
 * Describes the enum cortado.v1.QuoteStatusEnum.
 */
export const QuoteStatusEnumSchema: GenEnum<QuoteStatusEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_settings, 5);

/**
 * QuoteRejectionReasonEnum is the structured category a customer picks when
 * declining a quote. Free-text detail is stored separately.
 *
 * @generated from enum cortado.v1.QuoteRejectionReasonEnum
 */
export enum QuoteRejectionReasonEnum {
  /**
   * @generated from enum value: QUOTE_REJECTION_REASON_UNSPECIFIED = 0;
   */
  QUOTE_REJECTION_REASON_UNSPECIFIED = 0,

  /**
   * @generated from enum value: QUOTE_REJECTION_REASON_PRICE_TOO_HIGH = 1;
   */
  QUOTE_REJECTION_REASON_PRICE_TOO_HIGH = 1,

  /**
   * @generated from enum value: QUOTE_REJECTION_REASON_CHOSE_ANOTHER_VENDOR = 2;
   */
  QUOTE_REJECTION_REASON_CHOSE_ANOTHER_VENDOR = 2,

  /**
   * @generated from enum value: QUOTE_REJECTION_REASON_DATE_OR_PLANS_CHANGED = 3;
   */
  QUOTE_REJECTION_REASON_DATE_OR_PLANS_CHANGED = 3,

  /**
   * @generated from enum value: QUOTE_REJECTION_REASON_EVENT_CANCELLED = 4;
   */
  QUOTE_REJECTION_REASON_EVENT_CANCELLED = 4,

  /**
   * @generated from enum value: QUOTE_REJECTION_REASON_SERVICES_NOT_A_FIT = 5;
   */
  QUOTE_REJECTION_REASON_SERVICES_NOT_A_FIT = 5,

  /**
   * @generated from enum value: QUOTE_REJECTION_REASON_OTHER = 6;
   */
  QUOTE_REJECTION_REASON_OTHER = 6,
}

/**
 * Describes the enum cortado.v1.QuoteRejectionReasonEnum.
 */
export const QuoteRejectionReasonEnumSchema: GenEnum<QuoteRejectionReasonEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_settings, 6);

/**
 * PaymentStatusEnum represents the status of a payment
 *
 * @generated from enum cortado.v1.PaymentStatusEnum
 */
export enum PaymentStatusEnum {
  /**
   * @generated from enum value: PAYMENT_STATUS_UNKNOWN = 0;
   */
  PAYMENT_STATUS_UNKNOWN = 0,

  /**
   * @generated from enum value: PAYMENT_STATUS_UNPAID = 1;
   */
  PAYMENT_STATUS_UNPAID = 1,

  /**
   * @generated from enum value: PAYMENT_STATUS_SUCCESS = 2;
   */
  PAYMENT_STATUS_SUCCESS = 2,

  /**
   * @generated from enum value: PAYMENT_STATUS_FAILED = 3;
   */
  PAYMENT_STATUS_FAILED = 3,

  /**
   * @generated from enum value: PAYMENT_STATUS_REFUNDED = 4;
   */
  PAYMENT_STATUS_REFUNDED = 4,

  /**
   * @generated from enum value: PAYMENT_STATUS_DISPUTED = 5;
   */
  PAYMENT_STATUS_DISPUTED = 5,
}

/**
 * Describes the enum cortado.v1.PaymentStatusEnum.
 */
export const PaymentStatusEnumSchema: GenEnum<PaymentStatusEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_settings, 7);

/**
 * InvoiceStatusEnum represents the status of an invoice
 *
 * @generated from enum cortado.v1.InvoiceStatusEnum
 */
export enum InvoiceStatusEnum {
  /**
   * @generated from enum value: INVOICE_STATUS_UNKNOWN = 0;
   */
  INVOICE_STATUS_UNKNOWN = 0,

  /**
   * @generated from enum value: INVOICE_STATUS_DRAFT = 1;
   */
  INVOICE_STATUS_DRAFT = 1,

  /**
   * @generated from enum value: INVOICE_STATUS_SENT = 2;
   */
  INVOICE_STATUS_SENT = 2,

  /**
   * @generated from enum value: INVOICE_STATUS_VIEWED = 3;
   */
  INVOICE_STATUS_VIEWED = 3,

  /**
   * @generated from enum value: INVOICE_STATUS_PAYMENT_PENDING = 4;
   */
  INVOICE_STATUS_PAYMENT_PENDING = 4,

  /**
   * @generated from enum value: INVOICE_STATUS_PARTIALLY_PAID = 5;
   */
  INVOICE_STATUS_PARTIALLY_PAID = 5,

  /**
   * @generated from enum value: INVOICE_STATUS_PAID = 6;
   */
  INVOICE_STATUS_PAID = 6,

  /**
   * @generated from enum value: INVOICE_STATUS_OVERDUE = 7;
   */
  INVOICE_STATUS_OVERDUE = 7,

  /**
   * @generated from enum value: INVOICE_STATUS_CANCELLED = 8;
   */
  INVOICE_STATUS_CANCELLED = 8,

  /**
   * @generated from enum value: INVOICE_STATUS_OVERPAID = 9;
   */
  INVOICE_STATUS_OVERPAID = 9,
}

/**
 * Describes the enum cortado.v1.InvoiceStatusEnum.
 */
export const InvoiceStatusEnumSchema: GenEnum<InvoiceStatusEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_settings, 8);

/**
 * PaymentScheduleStatusEnum represents the status of a payment schedule
 *
 * @generated from enum cortado.v1.PaymentScheduleStatusEnum
 */
export enum PaymentScheduleStatusEnum {
  /**
   * @generated from enum value: PAYMENT_SCHEDULE_STATUS_UNKNOWN = 0;
   */
  PAYMENT_SCHEDULE_STATUS_UNKNOWN = 0,

  /**
   * @generated from enum value: PAYMENT_SCHEDULE_STATUS_PENDING = 1;
   */
  PAYMENT_SCHEDULE_STATUS_PENDING = 1,

  /**
   * @generated from enum value: PAYMENT_SCHEDULE_STATUS_PARTIAL = 2;
   */
  PAYMENT_SCHEDULE_STATUS_PARTIAL = 2,

  /**
   * @generated from enum value: PAYMENT_SCHEDULE_STATUS_PAID = 3;
   */
  PAYMENT_SCHEDULE_STATUS_PAID = 3,

  /**
   * @generated from enum value: PAYMENT_SCHEDULE_STATUS_OVERDUE = 4;
   */
  PAYMENT_SCHEDULE_STATUS_OVERDUE = 4,

  /**
   * @generated from enum value: PAYMENT_SCHEDULE_STATUS_CANCELLED = 5;
   */
  PAYMENT_SCHEDULE_STATUS_CANCELLED = 5,

  /**
   * @generated from enum value: PAYMENT_SCHEDULE_STATUS_WAIVED = 6;
   */
  PAYMENT_SCHEDULE_STATUS_WAIVED = 6,

  /**
   * @generated from enum value: PAYMENT_SCHEDULE_STATUS_UNPAID = 7;
   */
  PAYMENT_SCHEDULE_STATUS_UNPAID = 7,

  /**
   * Payment submitted via checkout, awaiting confirmation
   *
   * @generated from enum value: PAYMENT_SCHEDULE_STATUS_PAYMENT_INITIATED = 8;
   */
  PAYMENT_SCHEDULE_STATUS_PAYMENT_INITIATED = 8,

  /**
   * @generated from enum value: PAYMENT_SCHEDULE_STATUS_REFUNDED = 9;
   */
  PAYMENT_SCHEDULE_STATUS_REFUNDED = 9,

  /**
   * @generated from enum value: PAYMENT_SCHEDULE_STATUS_DISPUTED = 10;
   */
  PAYMENT_SCHEDULE_STATUS_DISPUTED = 10,
}

/**
 * Describes the enum cortado.v1.PaymentScheduleStatusEnum.
 */
export const PaymentScheduleStatusEnumSchema: GenEnum<PaymentScheduleStatusEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_settings, 9);

/**
 * PaymentIntentStatusEnum represents the status of a Stripe payment intent
 *
 * @generated from enum cortado.v1.PaymentIntentStatusEnum
 */
export enum PaymentIntentStatusEnum {
  /**
   * @generated from enum value: PAYMENT_INTENT_STATUS_UNKNOWN = 0;
   */
  PAYMENT_INTENT_STATUS_UNKNOWN = 0,

  /**
   * @generated from enum value: PAYMENT_INTENT_STATUS_CREATED = 1;
   */
  PAYMENT_INTENT_STATUS_CREATED = 1,

  /**
   * @generated from enum value: PAYMENT_INTENT_STATUS_REQUIRES_PAYMENT_METHOD = 2;
   */
  PAYMENT_INTENT_STATUS_REQUIRES_PAYMENT_METHOD = 2,

  /**
   * @generated from enum value: PAYMENT_INTENT_STATUS_REQUIRES_CONFIRMATION = 3;
   */
  PAYMENT_INTENT_STATUS_REQUIRES_CONFIRMATION = 3,

  /**
   * @generated from enum value: PAYMENT_INTENT_STATUS_REQUIRES_ACTION = 4;
   */
  PAYMENT_INTENT_STATUS_REQUIRES_ACTION = 4,

  /**
   * @generated from enum value: PAYMENT_INTENT_STATUS_PROCESSING = 5;
   */
  PAYMENT_INTENT_STATUS_PROCESSING = 5,

  /**
   * @generated from enum value: PAYMENT_INTENT_STATUS_SUCCEEDED = 6;
   */
  PAYMENT_INTENT_STATUS_SUCCEEDED = 6,

  /**
   * @generated from enum value: PAYMENT_INTENT_STATUS_CANCELED = 7;
   */
  PAYMENT_INTENT_STATUS_CANCELED = 7,

  /**
   * @generated from enum value: PAYMENT_INTENT_STATUS_FAILED = 8;
   */
  PAYMENT_INTENT_STATUS_FAILED = 8,
}

/**
 * Describes the enum cortado.v1.PaymentIntentStatusEnum.
 */
export const PaymentIntentStatusEnumSchema: GenEnum<PaymentIntentStatusEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_settings, 10);

/**
 * StripePaymentStatusEnum represents the status of a Stripe Charge/Payment
 *
 * @generated from enum cortado.v1.StripePaymentStatusEnum
 */
export enum StripePaymentStatusEnum {
  /**
   * @generated from enum value: STRIPE_PAYMENT_STATUS_UNKNOWN = 0;
   */
  STRIPE_PAYMENT_STATUS_UNKNOWN = 0,

  /**
   * @generated from enum value: STRIPE_PAYMENT_STATUS_PENDING = 1;
   */
  STRIPE_PAYMENT_STATUS_PENDING = 1,

  /**
   * @generated from enum value: STRIPE_PAYMENT_STATUS_SUCCEEDED = 2;
   */
  STRIPE_PAYMENT_STATUS_SUCCEEDED = 2,

  /**
   * @generated from enum value: STRIPE_PAYMENT_STATUS_FAILED = 3;
   */
  STRIPE_PAYMENT_STATUS_FAILED = 3,
}

/**
 * Describes the enum cortado.v1.StripePaymentStatusEnum.
 */
export const StripePaymentStatusEnumSchema: GenEnum<StripePaymentStatusEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_settings, 11);

/**
 * DisputeStatusEnum represents the status of a Stripe dispute
 *
 * @generated from enum cortado.v1.DisputeStatusEnum
 */
export enum DisputeStatusEnum {
  /**
   * @generated from enum value: DISPUTE_STATUS_UNKNOWN = 0;
   */
  DISPUTE_STATUS_UNKNOWN = 0,

  /**
   * @generated from enum value: DISPUTE_STATUS_NEEDS_RESPONSE = 1;
   */
  DISPUTE_STATUS_NEEDS_RESPONSE = 1,

  /**
   * @generated from enum value: DISPUTE_STATUS_UNDER_REVIEW = 2;
   */
  DISPUTE_STATUS_UNDER_REVIEW = 2,

  /**
   * @generated from enum value: DISPUTE_STATUS_WON = 3;
   */
  DISPUTE_STATUS_WON = 3,

  /**
   * @generated from enum value: DISPUTE_STATUS_LOST = 4;
   */
  DISPUTE_STATUS_LOST = 4,

  /**
   * @generated from enum value: DISPUTE_STATUS_WARNING_NEEDS_RESPONSE = 5;
   */
  DISPUTE_STATUS_WARNING_NEEDS_RESPONSE = 5,

  /**
   * @generated from enum value: DISPUTE_STATUS_WARNING_UNDER_REVIEW = 6;
   */
  DISPUTE_STATUS_WARNING_UNDER_REVIEW = 6,

  /**
   * @generated from enum value: DISPUTE_STATUS_WARNING_CLOSED = 7;
   */
  DISPUTE_STATUS_WARNING_CLOSED = 7,

  /**
   * @generated from enum value: DISPUTE_STATUS_CHARGE_REFUNDED = 8;
   */
  DISPUTE_STATUS_CHARGE_REFUNDED = 8,
}

/**
 * Describes the enum cortado.v1.DisputeStatusEnum.
 */
export const DisputeStatusEnumSchema: GenEnum<DisputeStatusEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_settings, 12);

/**
 * PaymentOutcomeTypeEnum represents the outcome type of a Stripe charge
 *
 * @generated from enum cortado.v1.PaymentOutcomeTypeEnum
 */
export enum PaymentOutcomeTypeEnum {
  /**
   * @generated from enum value: PAYMENT_OUTCOME_TYPE_UNKNOWN = 0;
   */
  PAYMENT_OUTCOME_TYPE_UNKNOWN = 0,

  /**
   * @generated from enum value: PAYMENT_OUTCOME_TYPE_AUTHORIZED = 1;
   */
  PAYMENT_OUTCOME_TYPE_AUTHORIZED = 1,

  /**
   * @generated from enum value: PAYMENT_OUTCOME_TYPE_BLOCKED = 2;
   */
  PAYMENT_OUTCOME_TYPE_BLOCKED = 2,

  /**
   * @generated from enum value: PAYMENT_OUTCOME_TYPE_INVALID = 3;
   */
  PAYMENT_OUTCOME_TYPE_INVALID = 3,

  /**
   * @generated from enum value: PAYMENT_OUTCOME_TYPE_ISSUER_DECLINED = 4;
   */
  PAYMENT_OUTCOME_TYPE_ISSUER_DECLINED = 4,

  /**
   * @generated from enum value: PAYMENT_OUTCOME_TYPE_MANUAL_REVIEW = 5;
   */
  PAYMENT_OUTCOME_TYPE_MANUAL_REVIEW = 5,
}

/**
 * Describes the enum cortado.v1.PaymentOutcomeTypeEnum.
 */
export const PaymentOutcomeTypeEnumSchema: GenEnum<PaymentOutcomeTypeEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_settings, 13);

/**
 * PaymentNetworkStatusEnum represents the network status of a charge
 *
 * @generated from enum cortado.v1.PaymentNetworkStatusEnum
 */
export enum PaymentNetworkStatusEnum {
  /**
   * @generated from enum value: PAYMENT_NETWORK_STATUS_UNKNOWN = 0;
   */
  PAYMENT_NETWORK_STATUS_UNKNOWN = 0,

  /**
   * @generated from enum value: PAYMENT_NETWORK_STATUS_APPROVED_BY_NETWORK = 1;
   */
  PAYMENT_NETWORK_STATUS_APPROVED_BY_NETWORK = 1,

  /**
   * @generated from enum value: PAYMENT_NETWORK_STATUS_DECLINED_BY_NETWORK = 2;
   */
  PAYMENT_NETWORK_STATUS_DECLINED_BY_NETWORK = 2,

  /**
   * @generated from enum value: PAYMENT_NETWORK_STATUS_NOT_SENT_TO_NETWORK = 3;
   */
  PAYMENT_NETWORK_STATUS_NOT_SENT_TO_NETWORK = 3,
}

/**
 * Describes the enum cortado.v1.PaymentNetworkStatusEnum.
 */
export const PaymentNetworkStatusEnumSchema: GenEnum<PaymentNetworkStatusEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_settings, 14);

/**
 * PaymentRiskLevelEnum represents the fraud risk level
 *
 * @generated from enum cortado.v1.PaymentRiskLevelEnum
 */
export enum PaymentRiskLevelEnum {
  /**
   * @generated from enum value: PAYMENT_RISK_LEVEL_UNKNOWN = 0;
   */
  PAYMENT_RISK_LEVEL_UNKNOWN = 0,

  /**
   * @generated from enum value: PAYMENT_RISK_LEVEL_NORMAL = 1;
   */
  PAYMENT_RISK_LEVEL_NORMAL = 1,

  /**
   * @generated from enum value: PAYMENT_RISK_LEVEL_ELEVATED = 2;
   */
  PAYMENT_RISK_LEVEL_ELEVATED = 2,

  /**
   * @generated from enum value: PAYMENT_RISK_LEVEL_HIGHEST = 3;
   */
  PAYMENT_RISK_LEVEL_HIGHEST = 3,
}

/**
 * Describes the enum cortado.v1.PaymentRiskLevelEnum.
 */
export const PaymentRiskLevelEnumSchema: GenEnum<PaymentRiskLevelEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_settings, 15);

/**
 * CardCheckResultEnum represents card verification check results
 *
 * @generated from enum cortado.v1.CardCheckResultEnum
 */
export enum CardCheckResultEnum {
  /**
   * @generated from enum value: CARD_CHECK_RESULT_UNKNOWN = 0;
   */
  CARD_CHECK_RESULT_UNKNOWN = 0,

  /**
   * @generated from enum value: CARD_CHECK_RESULT_PASS = 1;
   */
  CARD_CHECK_RESULT_PASS = 1,

  /**
   * @generated from enum value: CARD_CHECK_RESULT_FAIL = 2;
   */
  CARD_CHECK_RESULT_FAIL = 2,

  /**
   * @generated from enum value: CARD_CHECK_RESULT_UNAVAILABLE = 3;
   */
  CARD_CHECK_RESULT_UNAVAILABLE = 3,

  /**
   * @generated from enum value: CARD_CHECK_RESULT_UNCHECKED = 4;
   */
  CARD_CHECK_RESULT_UNCHECKED = 4,
}

/**
 * Describes the enum cortado.v1.CardCheckResultEnum.
 */
export const CardCheckResultEnumSchema: GenEnum<CardCheckResultEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_settings, 16);

/**
 * ManualPaymentMethodEnum represents payment methods for manual (non-Stripe) payments
 *
 * @generated from enum cortado.v1.ManualPaymentMethodEnum
 */
export enum ManualPaymentMethodEnum {
  /**
   * @generated from enum value: MANUAL_PAYMENT_METHOD_UNKNOWN = 0;
   */
  MANUAL_PAYMENT_METHOD_UNKNOWN = 0,

  /**
   * @generated from enum value: MANUAL_PAYMENT_METHOD_CHECK = 1;
   */
  MANUAL_PAYMENT_METHOD_CHECK = 1,

  /**
   * @generated from enum value: MANUAL_PAYMENT_METHOD_WIRE_TRANSFER = 2;
   */
  MANUAL_PAYMENT_METHOD_WIRE_TRANSFER = 2,

  /**
   * @generated from enum value: MANUAL_PAYMENT_METHOD_CASH = 3;
   */
  MANUAL_PAYMENT_METHOD_CASH = 3,

  /**
   * @generated from enum value: MANUAL_PAYMENT_METHOD_ACH = 4;
   */
  MANUAL_PAYMENT_METHOD_ACH = 4,
}

/**
 * Describes the enum cortado.v1.ManualPaymentMethodEnum.
 */
export const ManualPaymentMethodEnumSchema: GenEnum<ManualPaymentMethodEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_settings, 17);

/**
 * StripeCheckoutPaymentMethodEnum represents payment methods available in Stripe Checkout
 *
 * @generated from enum cortado.v1.StripeCheckoutPaymentMethodEnum
 */
export enum StripeCheckoutPaymentMethodEnum {
  /**
   * @generated from enum value: STRIPE_CHECKOUT_PAYMENT_METHOD_UNKNOWN = 0;
   */
  STRIPE_CHECKOUT_PAYMENT_METHOD_UNKNOWN = 0,

  /**
   * @generated from enum value: STRIPE_CHECKOUT_PAYMENT_METHOD_CARD = 1;
   */
  STRIPE_CHECKOUT_PAYMENT_METHOD_CARD = 1,

  /**
   * @generated from enum value: STRIPE_CHECKOUT_PAYMENT_METHOD_US_BANK_ACCOUNT = 2;
   */
  STRIPE_CHECKOUT_PAYMENT_METHOD_US_BANK_ACCOUNT = 2,
}

/**
 * Describes the enum cortado.v1.StripeCheckoutPaymentMethodEnum.
 */
export const StripeCheckoutPaymentMethodEnumSchema: GenEnum<StripeCheckoutPaymentMethodEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_settings, 18);

/**
 * ItemUnitEnum represents the unit for pricing items
 *
 * @generated from enum cortado.v1.ItemUnitEnum
 */
export enum ItemUnitEnum {
  /**
   * @generated from enum value: ITEM_UNIT_UNKNOWN = 0;
   */
  ITEM_UNIT_UNKNOWN = 0,

  /**
   * @generated from enum value: ITEM_UNIT_PER_EVENT = 1;
   */
  ITEM_UNIT_PER_EVENT = 1,

  /**
   * @generated from enum value: ITEM_UNIT_PER_HOUR = 2;
   */
  ITEM_UNIT_PER_HOUR = 2,

  /**
   * @generated from enum value: ITEM_UNIT_PER_DAY = 3;
   */
  ITEM_UNIT_PER_DAY = 3,

  /**
   * @generated from enum value: ITEM_UNIT_PER_UNIT = 4;
   */
  ITEM_UNIT_PER_UNIT = 4,

  /**
   * @generated from enum value: ITEM_UNIT_PER_MILE = 5;
   */
  ITEM_UNIT_PER_MILE = 5,
}

/**
 * Describes the enum cortado.v1.ItemUnitEnum.
 */
export const ItemUnitEnumSchema: GenEnum<ItemUnitEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_settings, 19);

/**
 * ItemKindEnum distinguishes ordinary catalog entries from the one
 * organization-level transportation configuration.
 *
 * @generated from enum cortado.v1.ItemKindEnum
 */
export enum ItemKindEnum {
  /**
   * @generated from enum value: ITEM_KIND_ENUM_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ITEM_KIND_ENUM_STANDARD = 1;
   */
  STANDARD = 1,

  /**
   * @generated from enum value: ITEM_KIND_ENUM_TRANSPORTATION = 2;
   */
  TRANSPORTATION = 2,
}

/**
 * Describes the enum cortado.v1.ItemKindEnum.
 */
export const ItemKindEnumSchema: GenEnum<ItemKindEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_settings, 20);

/**
 * ParentTypeEnum represents the type of parent entity
 *
 * @generated from enum cortado.v1.ParentTypeEnum
 */
export enum ParentTypeEnum {
  /**
   * @generated from enum value: PARENT_TYPE_UNKNOWN = 0;
   */
  PARENT_TYPE_UNKNOWN = 0,

  /**
   * @generated from enum value: PARENT_TYPE_ORGANIZATION = 1;
   */
  PARENT_TYPE_ORGANIZATION = 1,

  /**
   * @generated from enum value: PARENT_TYPE_INQUIRY = 2;
   */
  PARENT_TYPE_INQUIRY = 2,

  /**
   * @generated from enum value: PARENT_TYPE_BOOKING = 3;
   */
  PARENT_TYPE_BOOKING = 3,

  /**
   * @generated from enum value: PARENT_TYPE_EVENT = 4;
   */
  PARENT_TYPE_EVENT = 4,

  /**
   * @generated from enum value: PARENT_TYPE_CONTACT = 5;
   */
  PARENT_TYPE_CONTACT = 5,

  /**
   * @generated from enum value: PARENT_TYPE_ITEM = 6;
   */
  PARENT_TYPE_ITEM = 6,

  /**
   * @generated from enum value: PARENT_TYPE_QUOTE = 7;
   */
  PARENT_TYPE_QUOTE = 7,

  /**
   * @generated from enum value: PARENT_TYPE_SALES_TAX = 8;
   */
  PARENT_TYPE_SALES_TAX = 8,

  /**
   * @generated from enum value: PARENT_TYPE_INVOICE = 9;
   */
  PARENT_TYPE_INVOICE = 9,

  /**
   * @generated from enum value: PARENT_TYPE_NOTE = 10;
   */
  PARENT_TYPE_NOTE = 10,

  /**
   * @generated from enum value: PARENT_TYPE_TASK = 11;
   */
  PARENT_TYPE_TASK = 11,

  /**
   * @generated from enum value: PARENT_TYPE_EMAIL = 12;
   */
  PARENT_TYPE_EMAIL = 12,

  /**
   * @generated from enum value: PARENT_TYPE_ORGANIZATION_ROLE = 13;
   */
  PARENT_TYPE_ORGANIZATION_ROLE = 13,

  /**
   * @generated from enum value: PARENT_TYPE_EMAIL_TEMPLATE = 14;
   */
  PARENT_TYPE_EMAIL_TEMPLATE = 14,

  /**
   * @generated from enum value: PARENT_TYPE_ACTOR = 15;
   */
  PARENT_TYPE_ACTOR = 15,

  /**
   * @generated from enum value: PARENT_TYPE_DISCOUNT = 16;
   */
  PARENT_TYPE_DISCOUNT = 16,

  /**
   * @generated from enum value: PARENT_TYPE_COMPANY = 17;
   */
  PARENT_TYPE_COMPANY = 17,

  /**
   * @generated from enum value: PARENT_TYPE_PAYMENT = 18;
   */
  PARENT_TYPE_PAYMENT = 18,

  /**
   * @generated from enum value: PARENT_TYPE_ATTACHMENT = 19;
   */
  PARENT_TYPE_ATTACHMENT = 19,

  /**
   * @generated from enum value: PARENT_TYPE_ATTACHMENT_FOLDER = 20;
   */
  PARENT_TYPE_ATTACHMENT_FOLDER = 20,

  /**
   * @generated from enum value: PARENT_TYPE_JOB = 21;
   */
  PARENT_TYPE_JOB = 21,
}

/**
 * Describes the enum cortado.v1.ParentTypeEnum.
 */
export const ParentTypeEnumSchema: GenEnum<ParentTypeEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_settings, 21);

/**
 * PortalAttributionModeEnum describes what a portal credential is intended to
 * identify. Recipient attribution names the intended recipient, not a verified
 * opener. Anonymous attribution identifies only an organization-scoped browser.
 *
 * @generated from enum cortado.v1.PortalAttributionModeEnum
 */
export enum PortalAttributionModeEnum {
  /**
   * @generated from enum value: PORTAL_ATTRIBUTION_MODE_UNSPECIFIED = 0;
   */
  PORTAL_ATTRIBUTION_MODE_UNSPECIFIED = 0,

  /**
   * @generated from enum value: PORTAL_ATTRIBUTION_MODE_RECIPIENT = 1;
   */
  PORTAL_ATTRIBUTION_MODE_RECIPIENT = 1,

  /**
   * @generated from enum value: PORTAL_ATTRIBUTION_MODE_ANONYMOUS = 2;
   */
  PORTAL_ATTRIBUTION_MODE_ANONYMOUS = 2,

  /**
   * @generated from enum value: PORTAL_ATTRIBUTION_MODE_LEGACY_UNATTRIBUTED = 3;
   */
  PORTAL_ATTRIBUTION_MODE_LEGACY_UNATTRIBUTED = 3,
}

/**
 * Describes the enum cortado.v1.PortalAttributionModeEnum.
 */
export const PortalAttributionModeEnumSchema: GenEnum<PortalAttributionModeEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_settings, 22);

/**
 * PortalLinkIssuanceChannelEnum records how a portal alias was created.
 *
 * @generated from enum cortado.v1.PortalLinkIssuanceChannelEnum
 */
export enum PortalLinkIssuanceChannelEnum {
  /**
   * @generated from enum value: PORTAL_LINK_ISSUANCE_CHANNEL_UNSPECIFIED = 0;
   */
  PORTAL_LINK_ISSUANCE_CHANNEL_UNSPECIFIED = 0,

  /**
   * @generated from enum value: PORTAL_LINK_ISSUANCE_CHANNEL_STAFF_COPY = 1;
   */
  PORTAL_LINK_ISSUANCE_CHANNEL_STAFF_COPY = 1,

  /**
   * @generated from enum value: PORTAL_LINK_ISSUANCE_CHANNEL_SYSTEM_EMAIL = 2;
   */
  PORTAL_LINK_ISSUANCE_CHANNEL_SYSTEM_EMAIL = 2,

  /**
   * @generated from enum value: PORTAL_LINK_ISSUANCE_CHANNEL_MANUAL_EMAIL = 3;
   */
  PORTAL_LINK_ISSUANCE_CHANNEL_MANUAL_EMAIL = 3,

  /**
   * @generated from enum value: PORTAL_LINK_ISSUANCE_CHANNEL_CUSTOMER_EMAIL = 4;
   */
  PORTAL_LINK_ISSUANCE_CHANNEL_CUSTOMER_EMAIL = 4,

  /**
   * @generated from enum value: PORTAL_LINK_ISSUANCE_CHANNEL_CUSTOMER_COPY = 5;
   */
  PORTAL_LINK_ISSUANCE_CHANNEL_CUSTOMER_COPY = 5,

  /**
   * @generated from enum value: PORTAL_LINK_ISSUANCE_CHANNEL_RESEND = 6;
   */
  PORTAL_LINK_ISSUANCE_CHANNEL_RESEND = 6,

  /**
   * @generated from enum value: PORTAL_LINK_ISSUANCE_CHANNEL_LEGACY = 7;
   */
  PORTAL_LINK_ISSUANCE_CHANNEL_LEGACY = 7,
}

/**
 * Describes the enum cortado.v1.PortalLinkIssuanceChannelEnum.
 */
export const PortalLinkIssuanceChannelEnumSchema: GenEnum<PortalLinkIssuanceChannelEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_settings, 23);

/**
 * DiscountTypeEnum represents the type of discount
 *
 * @generated from enum cortado.v1.DiscountTypeEnum
 */
export enum DiscountTypeEnum {
  /**
   * @generated from enum value: DISCOUNT_TYPE_UNKNOWN = 0;
   */
  DISCOUNT_TYPE_UNKNOWN = 0,

  /**
   * @generated from enum value: DISCOUNT_TYPE_PERCENTAGE = 1;
   */
  DISCOUNT_TYPE_PERCENTAGE = 1,

  /**
   * @generated from enum value: DISCOUNT_TYPE_FIXED = 2;
   */
  DISCOUNT_TYPE_FIXED = 2,
}

/**
 * Describes the enum cortado.v1.DiscountTypeEnum.
 */
export const DiscountTypeEnumSchema: GenEnum<DiscountTypeEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_settings, 24);

/**
 * QuotePaymentScheduleAmountTypeEnum represents the type of amount for quote payment schedules
 *
 * @generated from enum cortado.v1.QuotePaymentScheduleAmountTypeEnum
 */
export enum QuotePaymentScheduleAmountTypeEnum {
  /**
   * @generated from enum value: QUOTE_PAYMENT_SCHEDULE_AMOUNT_TYPE_UNKNOWN = 0;
   */
  QUOTE_PAYMENT_SCHEDULE_AMOUNT_TYPE_UNKNOWN = 0,

  /**
   * @generated from enum value: QUOTE_PAYMENT_SCHEDULE_AMOUNT_TYPE_PERCENTAGE = 1;
   */
  QUOTE_PAYMENT_SCHEDULE_AMOUNT_TYPE_PERCENTAGE = 1,

  /**
   * @generated from enum value: QUOTE_PAYMENT_SCHEDULE_AMOUNT_TYPE_FIXED = 2;
   */
  QUOTE_PAYMENT_SCHEDULE_AMOUNT_TYPE_FIXED = 2,
}

/**
 * Describes the enum cortado.v1.QuotePaymentScheduleAmountTypeEnum.
 */
export const QuotePaymentScheduleAmountTypeEnumSchema: GenEnum<QuotePaymentScheduleAmountTypeEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_settings, 25);

/**
 * QuotePaymentScheduleDueDateAnchorEnum describes how a quote payment
 * schedule due date is computed. UNSPECIFIED is treated as ABSOLUTE.
 *
 * @generated from enum cortado.v1.QuotePaymentScheduleDueDateAnchorEnum
 */
export enum QuotePaymentScheduleDueDateAnchorEnum {
  /**
   * @generated from enum value: QUOTE_PAYMENT_SCHEDULE_DUE_DATE_ANCHOR_UNSPECIFIED = 0;
   */
  QUOTE_PAYMENT_SCHEDULE_DUE_DATE_ANCHOR_UNSPECIFIED = 0,

  /**
   * @generated from enum value: QUOTE_PAYMENT_SCHEDULE_DUE_DATE_ANCHOR_ABSOLUTE = 1;
   */
  QUOTE_PAYMENT_SCHEDULE_DUE_DATE_ANCHOR_ABSOLUTE = 1,

  /**
   * @generated from enum value: QUOTE_PAYMENT_SCHEDULE_DUE_DATE_ANCHOR_AFTER_ACCEPTANCE = 2;
   */
  QUOTE_PAYMENT_SCHEDULE_DUE_DATE_ANCHOR_AFTER_ACCEPTANCE = 2,

  /**
   * @generated from enum value: QUOTE_PAYMENT_SCHEDULE_DUE_DATE_ANCHOR_BEFORE_EVENT = 3;
   */
  QUOTE_PAYMENT_SCHEDULE_DUE_DATE_ANCHOR_BEFORE_EVENT = 3,
}

/**
 * Describes the enum cortado.v1.QuotePaymentScheduleDueDateAnchorEnum.
 */
export const QuotePaymentScheduleDueDateAnchorEnumSchema: GenEnum<QuotePaymentScheduleDueDateAnchorEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_settings, 26);

/**
 * QuoteExpirationAnchorEnum describes how a quote's default valid-until date
 * is computed in the quote builder. UNSPECIFIED means after_create for org
 * defaults and inherit for event-type overrides.
 *
 * @generated from enum cortado.v1.QuoteExpirationAnchorEnum
 */
export enum QuoteExpirationAnchorEnum {
  /**
   * @generated from enum value: QUOTE_EXPIRATION_ANCHOR_UNSPECIFIED = 0;
   */
  QUOTE_EXPIRATION_ANCHOR_UNSPECIFIED = 0,

  /**
   * @generated from enum value: QUOTE_EXPIRATION_ANCHOR_AFTER_CREATE = 1;
   */
  QUOTE_EXPIRATION_ANCHOR_AFTER_CREATE = 1,

  /**
   * @generated from enum value: QUOTE_EXPIRATION_ANCHOR_BEFORE_EVENT = 2;
   */
  QUOTE_EXPIRATION_ANCHOR_BEFORE_EVENT = 2,
}

/**
 * Describes the enum cortado.v1.QuoteExpirationAnchorEnum.
 */
export const QuoteExpirationAnchorEnumSchema: GenEnum<QuoteExpirationAnchorEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_settings, 27);

/**
 * InvoicePaymentScheduleAdjustmentStrategyEnum controls how invoice total
 * changes are applied to editable payment schedule rows.
 *
 * @generated from enum cortado.v1.InvoicePaymentScheduleAdjustmentStrategyEnum
 */
export enum InvoicePaymentScheduleAdjustmentStrategyEnum {
  /**
   * @generated from enum value: INVOICE_PAYMENT_SCHEDULE_ADJUSTMENT_STRATEGY_UNKNOWN = 0;
   */
  INVOICE_PAYMENT_SCHEDULE_ADJUSTMENT_STRATEGY_UNKNOWN = 0,

  /**
   * @generated from enum value: INVOICE_PAYMENT_SCHEDULE_ADJUSTMENT_STRATEGY_LAST_PAYMENT = 1;
   */
  INVOICE_PAYMENT_SCHEDULE_ADJUSTMENT_STRATEGY_LAST_PAYMENT = 1,

  /**
   * @generated from enum value: INVOICE_PAYMENT_SCHEDULE_ADJUSTMENT_STRATEGY_NEW_PAYMENT = 2;
   */
  INVOICE_PAYMENT_SCHEDULE_ADJUSTMENT_STRATEGY_NEW_PAYMENT = 2,
}

/**
 * Describes the enum cortado.v1.InvoicePaymentScheduleAdjustmentStrategyEnum.
 */
export const InvoicePaymentScheduleAdjustmentStrategyEnumSchema: GenEnum<InvoicePaymentScheduleAdjustmentStrategyEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_settings, 28);

/**
 * UserSchedulingStatusEnum represents the status of user scheduling
 *
 * @generated from enum cortado.v1.UserSchedulingStatusEnum
 */
export enum UserSchedulingStatusEnum {
  /**
   * @generated from enum value: USER_SCHEDULING_STATUS_UNKNOWN = 0;
   */
  USER_SCHEDULING_STATUS_UNKNOWN = 0,

  /**
   * @generated from enum value: USER_SCHEDULING_STATUS_PENDING = 1;
   */
  USER_SCHEDULING_STATUS_PENDING = 1,

  /**
   * @generated from enum value: USER_SCHEDULING_STATUS_ACCEPTED = 2;
   */
  USER_SCHEDULING_STATUS_ACCEPTED = 2,

  /**
   * @generated from enum value: USER_SCHEDULING_STATUS_REJECTED = 3;
   */
  USER_SCHEDULING_STATUS_REJECTED = 3,
}

/**
 * Describes the enum cortado.v1.UserSchedulingStatusEnum.
 */
export const UserSchedulingStatusEnumSchema: GenEnum<UserSchedulingStatusEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_settings, 29);

/**
 * UserSchedulingRoleEnum is a staff assignment's fixed role on an event. An
 * event has at most one LEAD; the first person assigned becomes it.
 *
 * @generated from enum cortado.v1.UserSchedulingRoleEnum
 */
export enum UserSchedulingRoleEnum {
  /**
   * @generated from enum value: USER_SCHEDULING_ROLE_UNSPECIFIED = 0;
   */
  USER_SCHEDULING_ROLE_UNSPECIFIED = 0,

  /**
   * @generated from enum value: USER_SCHEDULING_ROLE_LEAD = 1;
   */
  USER_SCHEDULING_ROLE_LEAD = 1,

  /**
   * @generated from enum value: USER_SCHEDULING_ROLE_BARISTA = 2;
   */
  USER_SCHEDULING_ROLE_BARISTA = 2,
}

/**
 * Describes the enum cortado.v1.UserSchedulingRoleEnum.
 */
export const UserSchedulingRoleEnumSchema: GenEnum<UserSchedulingRoleEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_settings, 30);

/**
 * TaskStatusEnum represents the status of a task
 *
 * @generated from enum cortado.v1.TaskStatusEnum
 */
export enum TaskStatusEnum {
  /**
   * @generated from enum value: TASK_STATUS_UNKNOWN = 0;
   */
  TASK_STATUS_UNKNOWN = 0,

  /**
   * @generated from enum value: TASK_STATUS_NOT_STARTED = 1;
   */
  TASK_STATUS_NOT_STARTED = 1,

  /**
   * @generated from enum value: TASK_STATUS_IN_PROGRESS = 2;
   */
  TASK_STATUS_IN_PROGRESS = 2,

  /**
   * @generated from enum value: TASK_STATUS_COMPLETED = 3;
   */
  TASK_STATUS_COMPLETED = 3,
}

/**
 * Describes the enum cortado.v1.TaskStatusEnum.
 */
export const TaskStatusEnumSchema: GenEnum<TaskStatusEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_settings, 31);

/**
 * EmailBodyFetchStatusEnum represents the status of fetching an email body from its vendor
 *
 * @generated from enum cortado.v1.EmailBodyFetchStatusEnum
 */
export enum EmailBodyFetchStatusEnum {
  /**
   * @generated from enum value: EMAIL_BODY_FETCH_STATUS_ENUM_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: EMAIL_BODY_FETCH_STATUS_ENUM_PENDING = 1;
   */
  PENDING = 1,

  /**
   * @generated from enum value: EMAIL_BODY_FETCH_STATUS_ENUM_SUCCEEDED = 2;
   */
  SUCCEEDED = 2,

  /**
   * @generated from enum value: EMAIL_BODY_FETCH_STATUS_ENUM_FAILED = 3;
   */
  FAILED = 3,
}

/**
 * Describes the enum cortado.v1.EmailBodyFetchStatusEnum.
 */
export const EmailBodyFetchStatusEnumSchema: GenEnum<EmailBodyFetchStatusEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_settings, 32);

/**
 * EmailThreadLinkSourceEnum records how a conversation came to be linked to a
 * CRM entity. Mirrors the link_source CHECK constraint on
 * emails.email_thread_links.
 *
 * @generated from enum cortado.v1.EmailThreadLinkSourceEnum
 */
export enum EmailThreadLinkSourceEnum {
  /**
   * @generated from enum value: EMAIL_THREAD_LINK_SOURCE_UNSPECIFIED = 0;
   */
  EMAIL_THREAD_LINK_SOURCE_UNSPECIFIED = 0,

  /**
   * The inbound matcher inferred the link
   *
   * @generated from enum value: EMAIL_THREAD_LINK_SOURCE_AUTO_MATCH = 1;
   */
  EMAIL_THREAD_LINK_SOURCE_AUTO_MATCH = 1,

  /**
   * A user linked the conversation by hand
   *
   * @generated from enum value: EMAIL_THREAD_LINK_SOURCE_MANUAL = 2;
   */
  EMAIL_THREAD_LINK_SOURCE_MANUAL = 2,

  /**
   * The link came from the entity the send was composed against
   *
   * @generated from enum value: EMAIL_THREAD_LINK_SOURCE_SEND_CONTEXT = 3;
   */
  EMAIL_THREAD_LINK_SOURCE_SEND_CONTEXT = 3,
}

/**
 * Describes the enum cortado.v1.EmailThreadLinkSourceEnum.
 */
export const EmailThreadLinkSourceEnumSchema: GenEnum<EmailThreadLinkSourceEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_settings, 33);

/**
 * EmailMarketingCampaignStatusEnum represents the lifecycle of an admin email blast.
 *
 * @generated from enum cortado.v1.EmailMarketingCampaignStatusEnum
 */
export enum EmailMarketingCampaignStatusEnum {
  /**
   * @generated from enum value: EMAIL_MARKETING_CAMPAIGN_STATUS_ENUM_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: EMAIL_MARKETING_CAMPAIGN_STATUS_ENUM_DRAFT = 1;
   */
  DRAFT = 1,

  /**
   * @generated from enum value: EMAIL_MARKETING_CAMPAIGN_STATUS_ENUM_LAUNCHING = 2;
   */
  LAUNCHING = 2,

  /**
   * @generated from enum value: EMAIL_MARKETING_CAMPAIGN_STATUS_ENUM_SENT = 3;
   */
  SENT = 3,

  /**
   * @generated from enum value: EMAIL_MARKETING_CAMPAIGN_STATUS_ENUM_FAILED = 4;
   */
  FAILED = 4,
}

/**
 * Describes the enum cortado.v1.EmailMarketingCampaignStatusEnum.
 */
export const EmailMarketingCampaignStatusEnumSchema: GenEnum<EmailMarketingCampaignStatusEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_settings, 34);

/**
 * EmailMarketingChannelEnum represents the Resend topic used for an admin email blast.
 *
 * @generated from enum cortado.v1.EmailMarketingChannelEnum
 */
export enum EmailMarketingChannelEnum {
  /**
   * @generated from enum value: EMAIL_MARKETING_CHANNEL_ENUM_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: EMAIL_MARKETING_CHANNEL_ENUM_PRODUCT_UPDATES = 1;
   */
  PRODUCT_UPDATES = 1,

  /**
   * @generated from enum value: EMAIL_MARKETING_CHANNEL_ENUM_ANNOUNCEMENTS = 2;
   */
  ANNOUNCEMENTS = 2,
}

/**
 * Describes the enum cortado.v1.EmailMarketingChannelEnum.
 */
export const EmailMarketingChannelEnumSchema: GenEnum<EmailMarketingChannelEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_settings, 35);

/**
 * EmailMarketingAudienceEnum is who an email marketing campaign goes to. Each
 * audience is one Resend segment that contact sync keeps current, and a person
 * is in at most one of them.
 *
 * @generated from enum cortado.v1.EmailMarketingAudienceEnum
 */
export enum EmailMarketingAudienceEnum {
  /**
   * @generated from enum value: EMAIL_MARKETING_AUDIENCE_ENUM_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Members of an org that is trialing, active, past due or comped.
   *
   * @generated from enum value: EMAIL_MARKETING_AUDIENCE_ENUM_CURRENT_CUSTOMERS = 1;
   */
  CURRENT_CUSTOMERS = 1,

  /**
   * Members of an org that is read-only or expired, and of no current org.
   *
   * @generated from enum value: EMAIL_MARKETING_AUDIENCE_ENUM_PREVIOUS_CUSTOMERS = 2;
   */
  PREVIOUS_CUSTOMERS = 2,

  /**
   * Users with no org, or whose orgs never started a subscription.
   *
   * @generated from enum value: EMAIL_MARKETING_AUDIENCE_ENUM_NEVER_SUBSCRIBED = 3;
   */
  NEVER_SUBSCRIBED = 3,

  /**
   * Waitlist signups without a Cortado account.
   *
   * @generated from enum value: EMAIL_MARKETING_AUDIENCE_ENUM_WAITLIST = 4;
   */
  WAITLIST = 4,
}

/**
 * Describes the enum cortado.v1.EmailMarketingAudienceEnum.
 */
export const EmailMarketingAudienceEnumSchema: GenEnum<EmailMarketingAudienceEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_settings, 36);

/**
 * EmailMarketingResourceTypeEnum identifies the Resend resource family used by admin tooling.
 *
 * @generated from enum cortado.v1.EmailMarketingResourceTypeEnum
 */
export enum EmailMarketingResourceTypeEnum {
  /**
   * @generated from enum value: EMAIL_MARKETING_RESOURCE_TYPE_ENUM_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: EMAIL_MARKETING_RESOURCE_TYPE_ENUM_SEGMENT = 1;
   */
  SEGMENT = 1,

  /**
   * @generated from enum value: EMAIL_MARKETING_RESOURCE_TYPE_ENUM_TOPIC = 2;
   */
  TOPIC = 2,
}

/**
 * Describes the enum cortado.v1.EmailMarketingResourceTypeEnum.
 */
export const EmailMarketingResourceTypeEnumSchema: GenEnum<EmailMarketingResourceTypeEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_settings, 37);

/**
 * AnnouncementDisplayTypeEnum controls how a dashboard announcement is presented.
 *
 * @generated from enum cortado.v1.AnnouncementDisplayTypeEnum
 */
export enum AnnouncementDisplayTypeEnum {
  /**
   * @generated from enum value: ANNOUNCEMENT_DISPLAY_TYPE_ENUM_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ANNOUNCEMENT_DISPLAY_TYPE_ENUM_CARD = 1;
   */
  CARD = 1,

  /**
   * @generated from enum value: ANNOUNCEMENT_DISPLAY_TYPE_ENUM_MODAL = 2;
   */
  MODAL = 2,
}

/**
 * Describes the enum cortado.v1.AnnouncementDisplayTypeEnum.
 */
export const AnnouncementDisplayTypeEnumSchema: GenEnum<AnnouncementDisplayTypeEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_settings, 38);

/**
 * CheckoutSessionStatusEnum represents the status of a Stripe Checkout Session
 *
 * @generated from enum cortado.v1.CheckoutSessionStatusEnum
 */
export enum CheckoutSessionStatusEnum {
  /**
   * @generated from enum value: CHECKOUT_SESSION_STATUS_UNKNOWN = 0;
   */
  CHECKOUT_SESSION_STATUS_UNKNOWN = 0,

  /**
   * @generated from enum value: CHECKOUT_SESSION_STATUS_OPEN = 1;
   */
  CHECKOUT_SESSION_STATUS_OPEN = 1,

  /**
   * @generated from enum value: CHECKOUT_SESSION_STATUS_COMPLETE = 2;
   */
  CHECKOUT_SESSION_STATUS_COMPLETE = 2,

  /**
   * @generated from enum value: CHECKOUT_SESSION_STATUS_EXPIRED = 3;
   */
  CHECKOUT_SESSION_STATUS_EXPIRED = 3,

  /**
   * @generated from enum value: CHECKOUT_SESSION_STATUS_FAILED = 4;
   */
  CHECKOUT_SESSION_STATUS_FAILED = 4,
}

/**
 * Describes the enum cortado.v1.CheckoutSessionStatusEnum.
 */
export const CheckoutSessionStatusEnumSchema: GenEnum<CheckoutSessionStatusEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_settings, 39);

/**
 * FeedbackStageEnum represents the stage/status of user feedback
 *
 * @generated from enum cortado.v1.FeedbackStageEnum
 */
export enum FeedbackStageEnum {
  /**
   * @generated from enum value: FEEDBACK_STAGE_UNKNOWN = 0;
   */
  FEEDBACK_STAGE_UNKNOWN = 0,

  /**
   * @generated from enum value: FEEDBACK_STAGE_NEW = 1;
   */
  FEEDBACK_STAGE_NEW = 1,

  /**
   * @generated from enum value: FEEDBACK_STAGE_PLANNED = 2;
   */
  FEEDBACK_STAGE_PLANNED = 2,

  /**
   * @generated from enum value: FEEDBACK_STAGE_IN_PROGRESS = 3;
   */
  FEEDBACK_STAGE_IN_PROGRESS = 3,

  /**
   * @generated from enum value: FEEDBACK_STAGE_COMPLETE = 4;
   */
  FEEDBACK_STAGE_COMPLETE = 4,

  /**
   * @generated from enum value: FEEDBACK_STAGE_CANCELLED = 5;
   */
  FEEDBACK_STAGE_CANCELLED = 5,

  /**
   * @generated from enum value: FEEDBACK_STAGE_WONT_DO = 6;
   */
  FEEDBACK_STAGE_WONT_DO = 6,
}

/**
 * Describes the enum cortado.v1.FeedbackStageEnum.
 */
export const FeedbackStageEnumSchema: GenEnum<FeedbackStageEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_settings, 40);

/**
 * FeedbackTypeEnum represents the type/category of user feedback
 *
 * @generated from enum cortado.v1.FeedbackTypeEnum
 */
export enum FeedbackTypeEnum {
  /**
   * @generated from enum value: FEEDBACK_TYPE_UNKNOWN = 0;
   */
  FEEDBACK_TYPE_UNKNOWN = 0,

  /**
   * @generated from enum value: FEEDBACK_TYPE_NEW_FEATURE = 1;
   */
  FEEDBACK_TYPE_NEW_FEATURE = 1,

  /**
   * @generated from enum value: FEEDBACK_TYPE_BUG_FIX = 2;
   */
  FEEDBACK_TYPE_BUG_FIX = 2,

  /**
   * @generated from enum value: FEEDBACK_TYPE_IMPROVEMENT = 3;
   */
  FEEDBACK_TYPE_IMPROVEMENT = 3,

  /**
   * @generated from enum value: FEEDBACK_TYPE_QUESTION = 4;
   */
  FEEDBACK_TYPE_QUESTION = 4,
}

/**
 * Describes the enum cortado.v1.FeedbackTypeEnum.
 */
export const FeedbackTypeEnumSchema: GenEnum<FeedbackTypeEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_settings, 41);

/**
 * OrganizationRoleEnum represents a role within an organization
 *
 * @generated from enum cortado.v1.OrganizationRoleEnum
 */
export enum OrganizationRoleEnum {
  /**
   * @generated from enum value: ORGANIZATION_ROLE_UNKNOWN = 0;
   */
  ORGANIZATION_ROLE_UNKNOWN = 0,

  /**
   * @generated from enum value: ORGANIZATION_ROLE_OWNER = 1;
   */
  ORGANIZATION_ROLE_OWNER = 1,

  /**
   * @generated from enum value: ORGANIZATION_ROLE_ADMIN = 2;
   */
  ORGANIZATION_ROLE_ADMIN = 2,

  /**
   * @generated from enum value: ORGANIZATION_ROLE_BARISTA = 3;
   */
  ORGANIZATION_ROLE_BARISTA = 3,
}

/**
 * Describes the enum cortado.v1.OrganizationRoleEnum.
 */
export const OrganizationRoleEnumSchema: GenEnum<OrganizationRoleEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_settings, 42);

/**
 * OrganizationFeatureEnum represents a feature available to an organization
 *
 * @generated from enum cortado.v1.OrganizationFeatureEnum
 */
export enum OrganizationFeatureEnum {
  /**
   * @generated from enum value: ORGANIZATION_FEATURE_UNKNOWN = 0;
   */
  ORGANIZATION_FEATURE_UNKNOWN = 0,

  /**
   * @generated from enum value: ORGANIZATION_FEATURE_EMAIL = 1;
   */
  ORGANIZATION_FEATURE_EMAIL = 1,

  /**
   * @generated from enum value: ORGANIZATION_FEATURE_AI_TEMPLATES = 2;
   */
  ORGANIZATION_FEATURE_AI_TEMPLATES = 2,

  /**
   * @generated from enum value: ORGANIZATION_FEATURE_QUOTING = 4;
   */
  ORGANIZATION_FEATURE_QUOTING = 4,

  /**
   * @generated from enum value: ORGANIZATION_FEATURE_NOTIFIER = 5;
   */
  ORGANIZATION_FEATURE_NOTIFIER = 5,

  /**
   * @generated from enum value: ORGANIZATION_FEATURE_FORM_SUBDOMAIN = 6;
   */
  ORGANIZATION_FEATURE_FORM_SUBDOMAIN = 6,

  /**
   * @generated from enum value: ORGANIZATION_FEATURE_EMAIL_INBOX = 7;
   */
  ORGANIZATION_FEATURE_EMAIL_INBOX = 7,

  /**
   * @generated from enum value: ORGANIZATION_FEATURE_REPORTING = 8;
   */
  ORGANIZATION_FEATURE_REPORTING = 8,

  /**
   * @generated from enum value: ORGANIZATION_FEATURE_FOUNDER = 9;
   */
  ORGANIZATION_FEATURE_FOUNDER = 9,

  /**
   * @generated from enum value: ORGANIZATION_FEATURE_COLLECTIVE = 10;
   */
  ORGANIZATION_FEATURE_COLLECTIVE = 10,

  /**
   * @generated from enum value: ORGANIZATION_FEATURE_AI_AGENT = 12;
   */
  ORGANIZATION_FEATURE_AI_AGENT = 12,

  /**
   * @generated from enum value: ORGANIZATION_FEATURE_SUPPORT_CHAT = 14;
   */
  ORGANIZATION_FEATURE_SUPPORT_CHAT = 14,

  /**
   * @generated from enum value: ORGANIZATION_FEATURE_WORKFLOWS = 15;
   */
  ORGANIZATION_FEATURE_WORKFLOWS = 15,

  /**
   * Deprecated: no longer gates behavior. Tenant-owned custom form/portal domains are
   * available to all organizations. Retained for backward compatibility.
   * buf:lint:ignore ENUM_VALUE_PREFIX
   *
   * @generated from enum value: ORGANIZATION_FEATURE_CUSTOM_PUBLIC_DOMAINS = 16;
   */
  ORGANIZATION_FEATURE_CUSTOM_PUBLIC_DOMAINS = 16,

  /**
   * @generated from enum value: ORGANIZATION_FEATURE_FORM_THEMING = 17;
   */
  ORGANIZATION_FEATURE_FORM_THEMING = 17,

  /**
   * @generated from enum value: ORGANIZATION_FEATURE_QUOTE_ADDONS = 18;
   */
  ORGANIZATION_FEATURE_QUOTE_ADDONS = 18,

  /**
   * Gates AI agent autopilot (auto-execution of write actions without approval).
   * Replaced ORGANIZATION_FEATURE_AI_CHAT_AUTOPILOT.
   *
   * @generated from enum value: ORGANIZATION_FEATURE_AI_AGENT_AUTOPILOT = 19;
   */
  ORGANIZATION_FEATURE_AI_AGENT_AUTOPILOT = 19,

  /**
   * Gates the organization's read-only MCP server and OAuth connection flow.
   *
   * @generated from enum value: ORGANIZATION_FEATURE_MCP = 20;
   */
  ORGANIZATION_FEATURE_MCP = 20,

  /**
   * Gates tenant API keys and the external HTTP API (/api/v1/ext).
   *
   * @generated from enum value: ORGANIZATION_FEATURE_API_ACCESS = 21;
   */
  ORGANIZATION_FEATURE_API_ACCESS = 21,

  /**
   * Gates the tenant Jobs list, the first Jobs UI surface.
   *
   * @generated from enum value: ORGANIZATION_FEATURE_JOBS = 22;
   */
  ORGANIZATION_FEATURE_JOBS = 22,

  /**
   * Gates lead referrals. A referral reaches another organization only when
   * both organizations have it.
   *
   * @generated from enum value: ORGANIZATION_FEATURE_LEAD_REFERRALS = 23;
   */
  ORGANIZATION_FEATURE_LEAD_REFERRALS = 23,
}

/**
 * Describes the enum cortado.v1.OrganizationFeatureEnum.
 */
export const OrganizationFeatureEnumSchema: GenEnum<OrganizationFeatureEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_settings, 43);

/**
 * OrganizationFeatureStageEnum classifies how an OrganizationFeatureEnum value
 * is actually used today. Mirrors enums.OrganizationFeatureStage in the
 * backend lifecycle registry (the single source of truth); see
 * AdminListFeatureCatalog.
 *
 * @generated from enum cortado.v1.OrganizationFeatureStageEnum
 */
export enum OrganizationFeatureStageEnum {
  /**
   * @generated from enum value: ORGANIZATION_FEATURE_STAGE_UNKNOWN = 0;
   */
  ORGANIZATION_FEATURE_STAGE_UNKNOWN = 0,

  /**
   * A real feature flag: rolling out per organization, expected to
   * eventually graduate to GA or be retired.
   *
   * @generated from enum value: ORGANIZATION_FEATURE_STAGE_EXPERIMENTAL = 1;
   */
  ORGANIZATION_FEATURE_STAGE_EXPERIMENTAL = 1,

  /**
   * A permanent per-organization gate (a plan or paid entitlement). Never a
   * promotion candidate.
   *
   * @generated from enum value: ORGANIZATION_FEATURE_STAGE_ENTITLEMENT = 2;
   */
  ORGANIZATION_FEATURE_STAGE_ENTITLEMENT = 2,

  /**
   * Not a gate at all: the row marks a pricing tier read by subscription
   * product selection.
   *
   * @generated from enum value: ORGANIZATION_FEATURE_STAGE_TIER_MARKER = 3;
   */
  ORGANIZATION_FEATURE_STAGE_TIER_MARKER = 3,

  /**
   * Graduated: available to every organization, no code consults the flag.
   *
   * @generated from enum value: ORGANIZATION_FEATURE_STAGE_GA = 4;
   */
  ORGANIZATION_FEATURE_STAGE_GA = 4,

  /**
   * The gated capability was removed or superseded; no code consults it.
   *
   * @generated from enum value: ORGANIZATION_FEATURE_STAGE_RETIRED = 5;
   */
  ORGANIZATION_FEATURE_STAGE_RETIRED = 5,
}

/**
 * Describes the enum cortado.v1.OrganizationFeatureStageEnum.
 */
export const OrganizationFeatureStageEnumSchema: GenEnum<OrganizationFeatureStageEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_settings, 44);

/**
 * PermissionEnum represents a system-level permission
 * Deprecated: superseded by PermissionInfo's string-keyed vocabulary, which is not
 * bounded to a fixed enum and can grow without a proto change. Retained on Role and
 * the role-mutation RPCs for backward compatibility until clients migrate.
 *
 * @generated from enum cortado.v1.PermissionEnum
 */
export enum PermissionEnum {
  /**
   * @generated from enum value: PERMISSION_UNKNOWN = 0;
   */
  PERMISSION_UNKNOWN = 0,

  /**
   * @generated from enum value: PERMISSION_SYSTEM = 1;
   */
  PERMISSION_SYSTEM = 1,

  /**
   * @generated from enum value: PERMISSION_ADMIN = 2;
   */
  PERMISSION_ADMIN = 2,
}

/**
 * Describes the enum cortado.v1.PermissionEnum.
 */
export const PermissionEnumSchema: GenEnum<PermissionEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_settings, 45);

/**
 * OnboardingStepEnum represents organization onboarding steps
 *
 * @generated from enum cortado.v1.OnboardingStepEnum
 */
export enum OnboardingStepEnum {
  /**
   * @generated from enum value: ONBOARDING_STEP_UNKNOWN = 0;
   */
  ONBOARDING_STEP_UNKNOWN = 0,

  /**
   * @generated from enum value: ONBOARDING_STEP_CREATE_ORGANIZATION = 1;
   */
  ONBOARDING_STEP_CREATE_ORGANIZATION = 1,

  /**
   * @generated from enum value: ONBOARDING_STEP_CREATE_ITEMS = 2;
   */
  ONBOARDING_STEP_CREATE_ITEMS = 2,

  /**
   * @generated from enum value: ONBOARDING_STEP_SETUP_FORM = 3;
   */
  ONBOARDING_STEP_SETUP_FORM = 3,

  /**
   * @generated from enum value: ONBOARDING_STEP_INVITE_MEMBERS = 4;
   */
  ONBOARDING_STEP_INVITE_MEMBERS = 4,

  /**
   * @generated from enum value: ONBOARDING_STEP_CONNECT_EMAIL = 5;
   */
  ONBOARDING_STEP_CONNECT_EMAIL = 5,

  /**
   * @generated from enum value: ONBOARDING_STEP_CONNECT_STRIPE = 6;
   */
  ONBOARDING_STEP_CONNECT_STRIPE = 6,

  /**
   * @generated from enum value: ONBOARDING_STEP_SUBSCRIBE = 7;
   */
  ONBOARDING_STEP_SUBSCRIBE = 7,

  /**
   * @generated from enum value: ONBOARDING_STEP_EVENT_TYPES = 8;
   */
  ONBOARDING_STEP_EVENT_TYPES = 8,

  /**
   * @generated from enum value: ONBOARDING_STEP_SALES_TAX = 9;
   */
  ONBOARDING_STEP_SALES_TAX = 9,

  /**
   * @generated from enum value: ONBOARDING_STEP_FORM_THEME = 10;
   */
  ONBOARDING_STEP_FORM_THEME = 10,

  /**
   * @generated from enum value: ONBOARDING_STEP_FORM_CONFIRMATION = 11;
   */
  ONBOARDING_STEP_FORM_CONFIRMATION = 11,

  /**
   * @generated from enum value: ONBOARDING_STEP_FORM_DOMAIN = 12;
   */
  ONBOARDING_STEP_FORM_DOMAIN = 12,

  /**
   * @generated from enum value: ONBOARDING_STEP_PORTAL_DOMAIN = 13;
   */
  ONBOARDING_STEP_PORTAL_DOMAIN = 13,

  /**
   * @generated from enum value: ONBOARDING_STEP_PORTAL_TERMS = 14;
   */
  ONBOARDING_STEP_PORTAL_TERMS = 14,

  /**
   * @generated from enum value: ONBOARDING_STEP_PORTAL_TIPS = 15;
   */
  ONBOARDING_STEP_PORTAL_TIPS = 15,

  /**
   * @generated from enum value: ONBOARDING_STEP_CONNECT_CALENDAR = 16;
   */
  ONBOARDING_STEP_CONNECT_CALENDAR = 16,

  /**
   * @generated from enum value: ONBOARDING_STEP_CONNECT_SLACK = 17;
   */
  ONBOARDING_STEP_CONNECT_SLACK = 17,

  /**
   * @generated from enum value: ONBOARDING_STEP_CONNECT_MCP = 18;
   */
  ONBOARDING_STEP_CONNECT_MCP = 18,

  /**
   * @generated from enum value: ONBOARDING_STEP_LAUNCH = 19;
   */
  ONBOARDING_STEP_LAUNCH = 19,
}

/**
 * Describes the enum cortado.v1.OnboardingStepEnum.
 */
export const OnboardingStepEnumSchema: GenEnum<OnboardingStepEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_settings, 46);

/**
 * ActivityTypeEnum represents the type of activity in the activity feed
 *
 * @generated from enum cortado.v1.ActivityTypeEnum
 */
export enum ActivityTypeEnum {
  /**
   * @generated from enum value: ACTIVITY_TYPE_UNKNOWN = 0;
   */
  ACTIVITY_TYPE_UNKNOWN = 0,

  /**
   * Inquiry activities (1-9)
   *
   * @generated from enum value: ACTIVITY_TYPE_INQUIRY_CREATED = 1;
   */
  ACTIVITY_TYPE_INQUIRY_CREATED = 1,

  /**
   * @generated from enum value: ACTIVITY_TYPE_INQUIRY_STAGE_CHANGED = 2;
   */
  ACTIVITY_TYPE_INQUIRY_STAGE_CHANGED = 2,

  /**
   * Quote activities (10-19)
   *
   * @generated from enum value: ACTIVITY_TYPE_QUOTE_CREATED = 10;
   */
  ACTIVITY_TYPE_QUOTE_CREATED = 10,

  /**
   * @generated from enum value: ACTIVITY_TYPE_QUOTE_SENT = 11;
   */
  ACTIVITY_TYPE_QUOTE_SENT = 11,

  /**
   * @generated from enum value: ACTIVITY_TYPE_QUOTE_VIEWED = 12;
   */
  ACTIVITY_TYPE_QUOTE_VIEWED = 12,

  /**
   * @generated from enum value: ACTIVITY_TYPE_QUOTE_ACCEPTED = 13;
   */
  ACTIVITY_TYPE_QUOTE_ACCEPTED = 13,

  /**
   * @generated from enum value: ACTIVITY_TYPE_QUOTE_REJECTED = 14;
   */
  ACTIVITY_TYPE_QUOTE_REJECTED = 14,

  /**
   * @generated from enum value: ACTIVITY_TYPE_QUOTE_EXPIRED = 15;
   */
  ACTIVITY_TYPE_QUOTE_EXPIRED = 15,

  /**
   * Invoice activities (20-29)
   *
   * @generated from enum value: ACTIVITY_TYPE_INVOICE_CREATED = 20;
   */
  ACTIVITY_TYPE_INVOICE_CREATED = 20,

  /**
   * @generated from enum value: ACTIVITY_TYPE_INVOICE_SENT = 21;
   */
  ACTIVITY_TYPE_INVOICE_SENT = 21,

  /**
   * @generated from enum value: ACTIVITY_TYPE_INVOICE_VIEWED = 22;
   */
  ACTIVITY_TYPE_INVOICE_VIEWED = 22,

  /**
   * @generated from enum value: ACTIVITY_TYPE_INVOICE_OVERDUE = 23;
   */
  ACTIVITY_TYPE_INVOICE_OVERDUE = 23,

  /**
   * Payment activities (30-39)
   *
   * @generated from enum value: ACTIVITY_TYPE_PAYMENT_RECEIVED = 30;
   */
  ACTIVITY_TYPE_PAYMENT_RECEIVED = 30,

  /**
   * @generated from enum value: ACTIVITY_TYPE_PAYMENT_FAILED = 31;
   */
  ACTIVITY_TYPE_PAYMENT_FAILED = 31,

  /**
   * @generated from enum value: ACTIVITY_TYPE_PAYMENT_REFUNDED = 32;
   */
  ACTIVITY_TYPE_PAYMENT_REFUNDED = 32,

  /**
   * Event activities (40-49)
   *
   * @generated from enum value: ACTIVITY_TYPE_EVENT_CREATED = 40;
   */
  ACTIVITY_TYPE_EVENT_CREATED = 40,

  /**
   * @generated from enum value: ACTIVITY_TYPE_EVENT_UPDATED = 41;
   */
  ACTIVITY_TYPE_EVENT_UPDATED = 41,

  /**
   * @generated from enum value: ACTIVITY_TYPE_EVENT_COMPLETED = 42;
   */
  ACTIVITY_TYPE_EVENT_COMPLETED = 42,

  /**
   * @generated from enum value: ACTIVITY_TYPE_EVENT_CANCELLED = 43;
   */
  ACTIVITY_TYPE_EVENT_CANCELLED = 43,

  /**
   * Booking activities (50-59)
   *
   * @generated from enum value: ACTIVITY_TYPE_BOOKING_CREATED = 50;
   */
  ACTIVITY_TYPE_BOOKING_CREATED = 50,

  /**
   * @generated from enum value: ACTIVITY_TYPE_BOOKING_STAGE_CHANGED = 51;
   */
  ACTIVITY_TYPE_BOOKING_STAGE_CHANGED = 51,

  /**
   * Contact activities (60-69)
   *
   * @generated from enum value: ACTIVITY_TYPE_CONTACT_CREATED = 60;
   */
  ACTIVITY_TYPE_CONTACT_CREATED = 60,

  /**
   * Task activities (70-79)
   *
   * @generated from enum value: ACTIVITY_TYPE_TASK_CREATED = 70;
   */
  ACTIVITY_TYPE_TASK_CREATED = 70,

  /**
   * @generated from enum value: ACTIVITY_TYPE_TASK_COMPLETED = 71;
   */
  ACTIVITY_TYPE_TASK_COMPLETED = 71,

  /**
   * Email activities (80-89)
   *
   * @generated from enum value: ACTIVITY_TYPE_EMAIL_SENT = 80;
   */
  ACTIVITY_TYPE_EMAIL_SENT = 80,

  /**
   * @generated from enum value: ACTIVITY_TYPE_EMAIL_RECEIVED = 81;
   */
  ACTIVITY_TYPE_EMAIL_RECEIVED = 81,

  /**
   * Note activities (90-99)
   *
   * @generated from enum value: ACTIVITY_TYPE_NOTE_ADDED = 90;
   */
  ACTIVITY_TYPE_NOTE_ADDED = 90,
}

/**
 * Describes the enum cortado.v1.ActivityTypeEnum.
 */
export const ActivityTypeEnumSchema: GenEnum<ActivityTypeEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_settings, 47);

/**
 * ActorTypeEnum represents who triggered an activity
 *
 * @generated from enum cortado.v1.ActorTypeEnum
 */
export enum ActorTypeEnum {
  /**
   * @generated from enum value: ACTOR_TYPE_UNKNOWN = 0;
   */
  ACTOR_TYPE_UNKNOWN = 0,

  /**
   * Internal user (employee)
   *
   * @generated from enum value: ACTOR_TYPE_USER = 1;
   */
  ACTOR_TYPE_USER = 1,

  /**
   * External contact/customer
   *
   * @generated from enum value: ACTOR_TYPE_CONTACT = 2;
   */
  ACTOR_TYPE_CONTACT = 2,

  /**
   * Automated system action
   *
   * @generated from enum value: ACTOR_TYPE_SYSTEM = 3;
   */
  ACTOR_TYPE_SYSTEM = 3,
}

/**
 * Describes the enum cortado.v1.ActorTypeEnum.
 */
export const ActorTypeEnumSchema: GenEnum<ActorTypeEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_settings, 48);

/**
 * InquiryTagEnum represents quick-access tags for inquiries
 *
 * @generated from enum cortado.v1.InquiryTagEnum
 */
export enum InquiryTagEnum {
  /**
   * @generated from enum value: INQUIRY_TAG_UNKNOWN = 0;
   */
  INQUIRY_TAG_UNKNOWN = 0,

  /**
   * @generated from enum value: INQUIRY_TAG_FOLLOW_UP = 1;
   */
  INQUIRY_TAG_FOLLOW_UP = 1,

  /**
   * @generated from enum value: INQUIRY_TAG_URGENT = 2;
   */
  INQUIRY_TAG_URGENT = 2,

  /**
   * @generated from enum value: INQUIRY_TAG_HOT_LEAD = 3;
   */
  INQUIRY_TAG_HOT_LEAD = 3,

  /**
   * @generated from enum value: INQUIRY_TAG_VIP = 4;
   */
  INQUIRY_TAG_VIP = 4,

  /**
   * @generated from enum value: INQUIRY_TAG_WAITING = 5;
   */
  INQUIRY_TAG_WAITING = 5,

  /**
   * The customer wrote last. Set from the lead's mail, like Waiting.
   *
   * @generated from enum value: INQUIRY_TAG_REPLY_NEEDED = 6;
   */
  INQUIRY_TAG_REPLY_NEEDED = 6,
}

/**
 * Describes the enum cortado.v1.InquiryTagEnum.
 */
export const InquiryTagEnumSchema: GenEnum<InquiryTagEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_settings, 49);

/**
 * InquiryRejectReasonEnum represents the reason an inquiry was rejected
 *
 * @generated from enum cortado.v1.InquiryRejectReasonEnum
 */
export enum InquiryRejectReasonEnum {
  /**
   * @generated from enum value: INQUIRY_REJECT_REASON_UNKNOWN = 0;
   */
  INQUIRY_REJECT_REASON_UNKNOWN = 0,

  /**
   * @generated from enum value: INQUIRY_REJECT_REASON_BUDGET = 1;
   */
  INQUIRY_REJECT_REASON_BUDGET = 1,

  /**
   * @generated from enum value: INQUIRY_REJECT_REASON_TIMING = 2;
   */
  INQUIRY_REJECT_REASON_TIMING = 2,

  /**
   * @generated from enum value: INQUIRY_REJECT_REASON_WENT_WITH_COMPETITOR = 3;
   */
  INQUIRY_REJECT_REASON_WENT_WITH_COMPETITOR = 3,

  /**
   * @generated from enum value: INQUIRY_REJECT_REASON_NO_RESPONSE = 4;
   */
  INQUIRY_REJECT_REASON_NO_RESPONSE = 4,

  /**
   * @generated from enum value: INQUIRY_REJECT_REASON_NOT_A_GOOD_FIT = 5;
   */
  INQUIRY_REJECT_REASON_NOT_A_GOOD_FIT = 5,

  /**
   * @generated from enum value: INQUIRY_REJECT_REASON_OTHER = 6;
   */
  INQUIRY_REJECT_REASON_OTHER = 6,
}

/**
 * Describes the enum cortado.v1.InquiryRejectReasonEnum.
 */
export const InquiryRejectReasonEnumSchema: GenEnum<InquiryRejectReasonEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_settings, 50);

/**
 * AgentModelProviderEnum identifies an LLM provider supported by AgentService.
 *
 * @generated from enum cortado.v1.AgentModelProviderEnum
 */
export enum AgentModelProviderEnum {
  /**
   * @generated from enum value: AGENT_MODEL_PROVIDER_ENUM_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: AGENT_MODEL_PROVIDER_ENUM_ANTHROPIC = 1;
   */
  ANTHROPIC = 1,

  /**
   * @generated from enum value: AGENT_MODEL_PROVIDER_ENUM_XAI = 2;
   */
  XAI = 2,
}

/**
 * Describes the enum cortado.v1.AgentModelProviderEnum.
 */
export const AgentModelProviderEnumSchema: GenEnum<AgentModelProviderEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_settings, 51);

/**
 * @generated from enum cortado.v1.LeadAssignmentModeEnum
 */
export enum LeadAssignmentModeEnum {
  /**
   * @generated from enum value: LEAD_ASSIGNMENT_MODE_UNSPECIFIED = 0;
   */
  LEAD_ASSIGNMENT_MODE_UNSPECIFIED = 0,

  /**
   * @generated from enum value: LEAD_ASSIGNMENT_MODE_UNASSIGNED = 1;
   */
  LEAD_ASSIGNMENT_MODE_UNASSIGNED = 1,

  /**
   * @generated from enum value: LEAD_ASSIGNMENT_MODE_DEFAULT_USER = 2;
   */
  LEAD_ASSIGNMENT_MODE_DEFAULT_USER = 2,

  /**
   * @generated from enum value: LEAD_ASSIGNMENT_MODE_ROUND_ROBIN = 3;
   */
  LEAD_ASSIGNMENT_MODE_ROUND_ROBIN = 3,
}

/**
 * Describes the enum cortado.v1.LeadAssignmentModeEnum.
 */
export const LeadAssignmentModeEnumSchema: GenEnum<LeadAssignmentModeEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_settings, 52);

/**
 * @generated from enum cortado.v1.JobPhaseEnum
 */
export enum JobPhaseEnum {
  /**
   * @generated from enum value: JOB_PHASE_UNSPECIFIED = 0;
   */
  JOB_PHASE_UNSPECIFIED = 0,

  /**
   * @generated from enum value: JOB_PHASE_NEW = 1;
   */
  JOB_PHASE_NEW = 1,

  /**
   * @generated from enum value: JOB_PHASE_QUOTING = 2;
   */
  JOB_PHASE_QUOTING = 2,

  /**
   * @generated from enum value: JOB_PHASE_BOOKED = 3;
   */
  JOB_PHASE_BOOKED = 3,

  /**
   * @generated from enum value: JOB_PHASE_COMPLETE = 4;
   */
  JOB_PHASE_COMPLETE = 4,
}

/**
 * Describes the enum cortado.v1.JobPhaseEnum.
 */
export const JobPhaseEnumSchema: GenEnum<JobPhaseEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_settings, 53);

/**
 * @generated from enum cortado.v1.JobStatusEnum
 */
export enum JobStatusEnum {
  /**
   * @generated from enum value: JOB_STATUS_UNSPECIFIED = 0;
   */
  JOB_STATUS_UNSPECIFIED = 0,

  /**
   * @generated from enum value: JOB_STATUS_OPEN = 1;
   */
  JOB_STATUS_OPEN = 1,

  /**
   * @generated from enum value: JOB_STATUS_STALE = 2;
   */
  JOB_STATUS_STALE = 2,

  /**
   * @generated from enum value: JOB_STATUS_LOST = 3;
   */
  JOB_STATUS_LOST = 3,

  /**
   * @generated from enum value: JOB_STATUS_CLOSED = 4;
   */
  JOB_STATUS_CLOSED = 4,
}

/**
 * Describes the enum cortado.v1.JobStatusEnum.
 */
export const JobStatusEnumSchema: GenEnum<JobStatusEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_settings, 54);

/**
 * @generated from enum cortado.v1.JobWaitingOnEnum
 */
export enum JobWaitingOnEnum {
  /**
   * @generated from enum value: JOB_WAITING_ON_UNSPECIFIED = 0;
   */
  JOB_WAITING_ON_UNSPECIFIED = 0,

  /**
   * @generated from enum value: JOB_WAITING_ON_THEM = 1;
   */
  JOB_WAITING_ON_THEM = 1,

  /**
   * @generated from enum value: JOB_WAITING_ON_US = 2;
   */
  JOB_WAITING_ON_US = 2,
}

/**
 * Describes the enum cortado.v1.JobWaitingOnEnum.
 */
export const JobWaitingOnEnumSchema: GenEnum<JobWaitingOnEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_settings, 55);

/**
 * @generated from enum cortado.v1.JobPaymentStateEnum
 */
export enum JobPaymentStateEnum {
  /**
   * @generated from enum value: JOB_PAYMENT_STATE_UNSPECIFIED = 0;
   */
  JOB_PAYMENT_STATE_UNSPECIFIED = 0,

  /**
   * @generated from enum value: JOB_PAYMENT_STATE_NONE = 1;
   */
  JOB_PAYMENT_STATE_NONE = 1,

  /**
   * @generated from enum value: JOB_PAYMENT_STATE_UNPAID = 2;
   */
  JOB_PAYMENT_STATE_UNPAID = 2,

  /**
   * @generated from enum value: JOB_PAYMENT_STATE_PARTIAL = 3;
   */
  JOB_PAYMENT_STATE_PARTIAL = 3,

  /**
   * @generated from enum value: JOB_PAYMENT_STATE_PAID = 4;
   */
  JOB_PAYMENT_STATE_PAID = 4,

  /**
   * @generated from enum value: JOB_PAYMENT_STATE_OVERDUE = 5;
   */
  JOB_PAYMENT_STATE_OVERDUE = 5,
}

/**
 * Describes the enum cortado.v1.JobPaymentStateEnum.
 */
export const JobPaymentStateEnumSchema: GenEnum<JobPaymentStateEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_settings, 56);

/**
 * JobBoardStageEnum is the Pipeline board column a job sits in. It refines
 * JobPhaseEnum: every stage belongs to exactly one phase. Derived server-side
 * (never stored) from inquiry stage, the latest quote's effective status (a
 * Sent/Viewed quote past valid_until counts as Expired, as in quote lists),
 * booking stage, and invoice payments. Pipeline order, which is also the
 * JOB_SORT_FIELD_BOARD_STAGE order and the stage_buckets order:
 * LEAD_NEW, LEAD_IN_PROGRESS, QUOTE_SENT, QUOTE_DECLINED,
 * BOOKING_NOT_INVOICED, BOOKING_PENDING_DEPOSIT, BOOKING_CONFIRMED, COMPLETE.
 * Numeric values are not in pipeline order.
 *
 * @generated from enum cortado.v1.JobBoardStageEnum
 */
export enum JobBoardStageEnum {
  /**
   * @generated from enum value: JOB_BOARD_STAGE_UNSPECIFIED = 0;
   */
  JOB_BOARD_STAGE_UNSPECIFIED = 0,

  /**
   * Phase NEW, and the inquiry's manually-set stage is still New (or there
   * is none). A draft/unsent quote does not affect this.
   *
   * @generated from enum value: JOB_BOARD_STAGE_LEAD_NEW = 1;
   */
  JOB_BOARD_STAGE_LEAD_NEW = 1,

  /**
   * Phase NEW, and the inquiry's manually-set stage is past New. A
   * draft/unsent quote does not affect this.
   *
   * @generated from enum value: JOB_BOARD_STAGE_LEAD_IN_PROGRESS = 2;
   */
  JOB_BOARD_STAGE_LEAD_IN_PROGRESS = 2,

  /**
   * Phase QUOTING, latest quote effectively Sent or Viewed. Also an Accepted
   * quote on a job that has no booking (not expected; see ListJobs docs).
   *
   * @generated from enum value: JOB_BOARD_STAGE_QUOTE_SENT = 4;
   */
  JOB_BOARD_STAGE_QUOTE_SENT = 4,

  /**
   * Phase QUOTING, latest quote effectively Rejected or Expired.
   *
   * @generated from enum value: JOB_BOARD_STAGE_QUOTE_DECLINED = 9;
   */
  JOB_BOARD_STAGE_QUOTE_DECLINED = 9,

  /**
   * Phase BOOKED, no non-cancelled invoice.
   *
   * @generated from enum value: JOB_BOARD_STAGE_BOOKING_NOT_INVOICED = 5;
   */
  JOB_BOARD_STAGE_BOOKING_NOT_INVOICED = 5,

  /**
   * Phase BOOKED, invoiced but nothing paid yet.
   *
   * @generated from enum value: JOB_BOARD_STAGE_BOOKING_PENDING_DEPOSIT = 6;
   */
  JOB_BOARD_STAGE_BOOKING_PENDING_DEPOSIT = 6,

  /**
   * Phase BOOKED, any payment received.
   *
   * @generated from enum value: JOB_BOARD_STAGE_BOOKING_CONFIRMED = 7;
   */
  JOB_BOARD_STAGE_BOOKING_CONFIRMED = 7,

  /**
   * Phase COMPLETE.
   *
   * @generated from enum value: JOB_BOARD_STAGE_COMPLETE = 8;
   */
  JOB_BOARD_STAGE_COMPLETE = 8,
}

/**
 * Describes the enum cortado.v1.JobBoardStageEnum.
 */
export const JobBoardStageEnumSchema: GenEnum<JobBoardStageEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_settings, 57);

/**
 * JobSortFieldEnum selects the ListJobs sort key. Every sort ends with a
 * stable job id tiebreak.
 *
 * @generated from enum cortado.v1.JobSortFieldEnum
 */
export enum JobSortFieldEnum {
  /**
   * Default pipeline order: phase, then who we are waiting on, then first
   * event date (nulls last), then most recently updated.
   *
   * @generated from enum value: JOB_SORT_FIELD_UNSPECIFIED = 0;
   */
  JOB_SORT_FIELD_UNSPECIFIED = 0,

  /**
   * Contact "first last", case-insensitive.
   *
   * @generated from enum value: JOB_SORT_FIELD_CUSTOMER_NAME = 1;
   */
  JOB_SORT_FIELD_CUSTOMER_NAME = 1,

  /**
   * @generated from enum value: JOB_SORT_FIELD_FIRST_EVENT_DATE = 2;
   */
  JOB_SORT_FIELD_FIRST_EVENT_DATE = 2,

  /**
   * Board stage in pipeline order (see JobBoardStageEnum), not numeric order.
   *
   * @generated from enum value: JOB_SORT_FIELD_BOARD_STAGE = 3;
   */
  JOB_SORT_FIELD_BOARD_STAGE = 3,

  /**
   * @generated from enum value: JOB_SORT_FIELD_QUOTED = 4;
   */
  JOB_SORT_FIELD_QUOTED = 4,

  /**
   * @generated from enum value: JOB_SORT_FIELD_PAID = 5;
   */
  JOB_SORT_FIELD_PAID = 5,

  /**
   * Assigned owner "first last", case-insensitive.
   *
   * @generated from enum value: JOB_SORT_FIELD_OWNER = 6;
   */
  JOB_SORT_FIELD_OWNER = 6,

  /**
   * @generated from enum value: JOB_SORT_FIELD_UPDATED_AT = 7;
   */
  JOB_SORT_FIELD_UPDATED_AT = 7,
}

/**
 * Describes the enum cortado.v1.JobSortFieldEnum.
 */
export const JobSortFieldEnumSchema: GenEnum<JobSortFieldEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_settings, 58);

/**
 * JobSortDirectionEnum is the ListJobs sort direction. Missing values (no
 * event date, no quote, no owner) sort last in both directions.
 *
 * @generated from enum cortado.v1.JobSortDirectionEnum
 */
export enum JobSortDirectionEnum {
  /**
   * Ascending.
   *
   * @generated from enum value: JOB_SORT_DIRECTION_UNSPECIFIED = 0;
   */
  JOB_SORT_DIRECTION_UNSPECIFIED = 0,

  /**
   * @generated from enum value: JOB_SORT_DIRECTION_ASC = 1;
   */
  JOB_SORT_DIRECTION_ASC = 1,

  /**
   * @generated from enum value: JOB_SORT_DIRECTION_DESC = 2;
   */
  JOB_SORT_DIRECTION_DESC = 2,
}

/**
 * Describes the enum cortado.v1.JobSortDirectionEnum.
 */
export const JobSortDirectionEnumSchema: GenEnum<JobSortDirectionEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_settings, 59);

/**
 * JobEventSourceEnum is the table a JobEventLite row comes from.
 *
 * @generated from enum cortado.v1.JobEventSourceEnum
 */
export enum JobEventSourceEnum {
  /**
   * @generated from enum value: JOB_EVENT_SOURCE_UNSPECIFIED = 0;
   */
  JOB_EVENT_SOURCE_UNSPECIFIED = 0,

  /**
   * events.events: a booked event (id is an Event id).
   *
   * @generated from enum value: JOB_EVENT_SOURCE_EVENT = 1;
   */
  JOB_EVENT_SOURCE_EVENT = 1,

  /**
   * events.inquiry_events: a requested date on a job not yet booked (id is an
   * InquiryEvent id).
   *
   * @generated from enum value: JOB_EVENT_SOURCE_INQUIRY_EVENT = 2;
   */
  JOB_EVENT_SOURCE_INQUIRY_EVENT = 2,
}

/**
 * Describes the enum cortado.v1.JobEventSourceEnum.
 */
export const JobEventSourceEnumSchema: GenEnum<JobEventSourceEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_settings, 60);

/**
 * @generated from enum cortado.v1.JobActivityCategoryEnum
 */
export enum JobActivityCategoryEnum {
  /**
   * @generated from enum value: JOB_ACTIVITY_CATEGORY_UNSPECIFIED = 0;
   */
  JOB_ACTIVITY_CATEGORY_UNSPECIFIED = 0,

  /**
   * @generated from enum value: JOB_ACTIVITY_CATEGORY_INQUIRY = 1;
   */
  JOB_ACTIVITY_CATEGORY_INQUIRY = 1,

  /**
   * @generated from enum value: JOB_ACTIVITY_CATEGORY_QUOTE = 2;
   */
  JOB_ACTIVITY_CATEGORY_QUOTE = 2,

  /**
   * @generated from enum value: JOB_ACTIVITY_CATEGORY_BOOKING = 3;
   */
  JOB_ACTIVITY_CATEGORY_BOOKING = 3,

  /**
   * @generated from enum value: JOB_ACTIVITY_CATEGORY_EVENT = 4;
   */
  JOB_ACTIVITY_CATEGORY_EVENT = 4,

  /**
   * @generated from enum value: JOB_ACTIVITY_CATEGORY_INVOICE = 5;
   */
  JOB_ACTIVITY_CATEGORY_INVOICE = 5,

  /**
   * @generated from enum value: JOB_ACTIVITY_CATEGORY_PAYMENT = 6;
   */
  JOB_ACTIVITY_CATEGORY_PAYMENT = 6,

  /**
   * @generated from enum value: JOB_ACTIVITY_CATEGORY_EMAIL = 7;
   */
  JOB_ACTIVITY_CATEGORY_EMAIL = 7,

  /**
   * @generated from enum value: JOB_ACTIVITY_CATEGORY_TASK = 8;
   */
  JOB_ACTIVITY_CATEGORY_TASK = 8,

  /**
   * @generated from enum value: JOB_ACTIVITY_CATEGORY_NOTE = 9;
   */
  JOB_ACTIVITY_CATEGORY_NOTE = 9,

  /**
   * @generated from enum value: JOB_ACTIVITY_CATEGORY_CONTACT = 10;
   */
  JOB_ACTIVITY_CATEGORY_CONTACT = 10,
}

/**
 * Describes the enum cortado.v1.JobActivityCategoryEnum.
 */
export const JobActivityCategoryEnumSchema: GenEnum<JobActivityCategoryEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_settings, 61);

/**
 * How a v1 invoice's outstanding tip is spread across payment schedules.
 *
 * @generated from enum cortado.v1.TipAllocationModeEnum
 */
export enum TipAllocationModeEnum {
  /**
   * request: not provided (create -> org default, update -> keep). response: treat as LAST_SCHEDULE
   *
   * @generated from enum value: TIP_ALLOCATION_MODE_UNSPECIFIED = 0;
   */
  TIP_ALLOCATION_MODE_UNSPECIFIED = 0,

  /**
   * whole outstanding tip on the last eligible schedule
   *
   * @generated from enum value: TIP_ALLOCATION_MODE_LAST_SCHEDULE = 1;
   */
  TIP_ALLOCATION_MODE_LAST_SCHEDULE = 1,

  /**
   * outstanding tip split across eligible schedules by base amount
   *
   * @generated from enum value: TIP_ALLOCATION_MODE_PRO_RATA = 2;
   */
  TIP_ALLOCATION_MODE_PRO_RATA = 2,
}

/**
 * Describes the enum cortado.v1.TipAllocationModeEnum.
 */
export const TipAllocationModeEnumSchema: GenEnum<TipAllocationModeEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_settings, 62);

